<template>
  <!-- 外部ユーザー編集 -->
  <div id="ExternalUserEdit" v-if="data">
    <div id="container">
      <template v-if="from !='control'">
        <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
        <div class="labelTitle lable">ユーザー管理</div>
        <userNavi v-bind:pageid='"ExternalUserSearch"'></userNavi>
      </template>
      <div class="labelTitle lable">外部ユーザー情報</div>
      <!-- 変更内容 -->
      <div>
        <div id="item-contens">
          <div v-if="from !='control' && data.userInfo.lock" class="card-content margin-top">
            <table>
              <tr>
                <td><span style="color: red">このユーザーはロック中です。</span><b-button class="is-primary unlockButton" @click="unLock">ロック解除</b-button></td>
              </tr>
            </table>
          </div>
          <div v-if="(data.belongInfo.role != role.role_hospital && data.belongInfo.role != role.role_dealer) || data.userInfo.status==extUserStatus.dummy" class="card-content margin-top">
            <span style="font-size:20px;">ユーザー情報</span>
            <table>
              <template v-if="data.userInfo.status==extUserStatus.dummy">
              <tr>
                <th></th>
                <td><span :class="getTagClass4ExtUserStatus(data.userInfo.status)">{{data.userInfo.status | extUserStatusFilter}}</span></td>
              </tr>
              </template>
              <tr><th>ユーザーID</th><td>{{data.userInfo.id}}</td></tr>
              <tr>
                <th>ユーザー名<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" placeholder="姓" v-model="data.userInfo.familyName" name="ユーザー名(姓)"  validate="required" maxlength="50"/>
                  <input class="nameInput validate" type="text" placeholder="名" v-model="data.userInfo.firstName" name="ユーザー名(名)"  validate="required" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>ユーザー名(カナ)<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" placeholder="セイ" v-model="data.userInfo.familyNameKana" name="ユーザー名(姓カナ)"  validate="required|kana" maxlength="50"/>
                  <input class="nameInput validate" type="text" placeholder="メイ" v-model="data.userInfo.firstNameKana" name="ユーザー名(名カナ)"  validate="required|kana" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>メールアドレス<span class="require" /></th>
                <td>
                  <input type="text" v-model="data.userInfo.mail" id="mailAddress" class="validate" name="メールアドレス"  validate="required|mail" maxlength="100"/>
                </td>
              </tr>
              <tr>
                <th>メールアドレス(確認)<span class="require" /></th>
                <td><input type="text" v-model="mailAddrcomfirm" class="validate" name="メールアドレス(確認)"  validate="required" maxlength="100"/></td>
              </tr>
              <tr v-if="data.userInfo.mailError"><th></th><td><span class="caution">メールの送信に失敗しています。受信可能なメールアドレスが正しく入力されていることを確認してください。</span></td></tr>
              <tr v-if="data.userInfo.status!=extUserStatus.dummy">
                <th> パスフレーズ認証</th>
                <td>
                  <b-checkbox class="cstmCheckBox" v-model="data.userInfo.passPhrase">二要素認証を行う</b-checkbox>
                </td>
              </tr>
              <tr v-if="data.userInfo.passPhrase">
                <th>パスフレーズ送信先<br>(携帯番号)</th>
                <td>
                  <input type="text" class="withButtonField validate" v-model="data.userInfo.passPhrasePhoneNumber" id="passphraseSendNo" name="パスフレーズ送信先(携帯番号)" validate="numeric" maxlength="20"/>
                  <b-button class="withButton" @click="sendTestSMS">テスト送信</b-button>
                </td>
              </tr>
              <tr v-if="data.userInfo.passPhrase">
                <th>パスフレーズ送信先<br>(Eメールアドレス)</th>
                <td>
                  <input type="text" class="withButtonField validate" v-model="data.userInfo.passPhraseMail" id="passphraseSendMail" name="送信先(Eメールアドレス)" validate="mail" maxlength="256"/>
                  <b-button class="withButton" @click="sendTestMail">テスト送信</b-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="card-content margin-top">
            <span style="font-size:20px;">組織情報</span>
            <table>
              <template v-if="data.userInfo.status==extUserStatus.dummy">
              <tr>
                <th></th>
                <td><span :class="getTagClass4ExtUserStatus(data.userInfo.status)">{{data.userInfo.status | extUserStatusFilter}}</span></td>
              </tr>
              </template>
              <tr><th>組織ID</th> <td>{{data.belongInfo.id}}</td></tr>
              <tr><th>種別<span class="require" /></th>
                <td><select v-model="data.belongInfo.role" :disabled="roleId != role.role_admin" class="validate" name="種別"  validate="required" >
                  <option :value="role.role_hospital">医療機関</option>
                  <option :value="role.role_corporation">企業</option>
                  <option :value="role.role_judgment">判定医療機関</option>
                  <option :value="role.role_holter_judgment">ホルター判定医</option>
                  <option :value="role.role_analysis">解析委託業者</option>
                  <option :value="role.role_dealer">ディーラー</option>
                  <option :value="role.role_accommodations">宿泊施設</option></select>
                </td>
              </tr>
              <tr>
                <th>企業名・医療機関名(表示用)<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.medicalInstitutionName" class="validate" name="企業名・医療機関名(表示用)" validate="required" maxlength="100"/></td>
              </tr>
              <tr v-if="data.belongInfo.role != role.role_analysis">
                <th>部署名・診療科名(表示用)<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.departmentName" maxlength="100" class="validate" name="部署名・診療科名(表示用)" validate="required"/></td>
              </tr>
              <tr>
                <th>郵便番号<span class="require" /></th>
                  <td>
                    <input
                      id="customerPostCode"
                      type="text"
                      class="withButtonField validate"
                      :class="{'border-red': invalidPostcode}"
                      v-model="data.belongInfo.customerPostCode"
                      name="郵便番号"
                      validate="required|numeric|zip"
                      maxlength="7"
                      :placeholder="postcodePlaceholder"
                      @blur="onZipBlur(data.belongInfo.customerPostCode, 'digitErrorPostcode')"
                    />
                  <b-button class="withButton" @click="postCodeSearch">自動入力</b-button>
                  <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                  <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                </td>
              </tr>
              <tr>
                <th>都道府県<span class="require" /></th>
                <td>
                  <select v-model="data.belongInfo.prefecture" class="validate" name="都道府県" validate="required">
                      <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>市町村区<span class="require" /></th>
                <td><input type="text" v-model="data.belongInfo.city" class="validate" name="市町村区" validate="required" maxlength="100"/></td>
              </tr>
              <tr>
                <th>住所（それ以降の住所）<span class="require"/></th>
                <td><input type="text" v-model="data.belongInfo.customerAddress1" class="validate" name="住所（それ以降の住所）" validate="required" maxlength="100" ref="customerAddress1"/></td>
              </tr>
              <tr>
                <th>住所（建物名、部屋番号）</th>
                <td><input type="text" v-model="data.belongInfo.customerAddress2" maxlength="100"/></td>
              </tr>
              <tr>
                <th>連絡先(電話番号)<span class="require" /></th>
                <td>
                  <input
                    type="text"
                    v-model="data.belongInfo.phoneNumber"
                    class="validate"
                    :class="{'border-red': invalidPhoneNumber}"
                    name="連絡先"
                    validate="required|numeric"
                    maxlength="11"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <template v-if="data.belongInfo.role == role.role_hospital &&data.userInfo.status!=extUserStatus.dummy">
                <tr>
                  <th></th>
                  <td>
                    <div>
                      <b-checkbox class="columnCheckBox" v-model="data.belongInfo.agreedInfoDisclosure">転院先施設として住所、連絡先（電話番号・メールアドレス）を公開する</b-checkbox>
                    </div>
                  </td>
                </tr>
                <template v-if="data.belongInfo.agreedInfoDisclosure">
                  <tr>
                    <th>連絡先メールアドレス<span class="require" /></th>
                    <td>
                      <input type="text" v-model="data.belongInfo.publicMail" class="withButtonField validate" id="publicMail" name="連絡先メールアドレス"  validate="required|mail" maxlength="256"/>
                      <b-button class="withButton" @click="sendTestPublicAddressMail">テスト送信</b-button>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-if="data.userInfo.status!=extUserStatus.dummy">
                <th style="vertical-align:top;">コメント</th>
                <td>
                  <textarea v-model="data.belongInfo.note" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea>
                </td>
              </tr>
              <template v-if="(data.belongInfo.role == role.role_hospital || data.belongInfo.role == role.role_dealer) && data.userInfo.status!=extUserStatus.dummy">
                <tr><th>巻き取り対象<span class="requireHeadOffice"/></th>
                  <td>
                    <select style="width:200px" v-model="data.belongInfo.takeupStatus">
                      <option value=0></option>
                      <option value=1>本社</option>
                      <option value=2>支店</option>
                    </select>
                  </td>
                </tr>
                <tr/>
                <tr>
                  <th>得意先情報<span class="requireHeadOffice"/></th>
                  <td v-if="data.belongInfo.role == role.role_hospital">
                    病院コード：<input type="text" disabled style="width:150px;" v-model="data.belongInfo.customerId"/>
                    &nbsp;&nbsp;名称：<input type="text" disabled style="width:430px;" v-model="data.belongInfo.customerName"/>
                    <b-button  class="is-primary withButton" v-on:click="customerModalActive=true" >得意先選択</b-button>
                  </td>
                  <td v-else-if="data.belongInfo.role == role.role_dealer">
                    請求先コード：<input type="text" disabled style="width:150px;" v-model="data.belongInfo.customerId"/>
                    &nbsp;&nbsp;名称：<input type="text" disabled style="width:415px;" v-model="data.belongInfo.customerName"/>
                    <b-button  class="is-primary withButton" v-on:click="customerModalActive=true" >請求先選択</b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当支店：
                      <select style="width:250px;" v-model="data.belongInfo.branchStore">
                        <option v-for="branch of branchOfficeMaster" :value="branch.code" :key="'d' + branch.code">
                          {{branch.name}}
                        </option>
                      </select>
                  </td>
                </tr>
              </template>
            </table>
          </div>
          <div v-if="(data.belongInfo.role == role.role_hospital || data.belongInfo.role == role.role_dealer) && data.userInfo.status!=extUserStatus.dummy" style="margin-top:20px;">
            <div class="card-content margin-top">
              <span style="font-size:20px;">ユーザー情報</span><br>
              <span style="display:inline-block; width:1050px;"></span>
              <b-button v-if="roleId==role.role_admin || roleId==role.role_headOffice || roleId==role.role_headOffice_division" icon-left="account-plus-outline" class="iconButton" v-on:click="userAddModalActive=true, userData={index:data.usersInfo.length,userStatus:-1,portalFlag:false}, editFlag=false, initialpDashboardInfo={integratorUser:'',integratorKey:'',orgId:''}"></b-button>
              <table class="condition-area">
                <tr>
                  <td>ユーザーID</td>
                  <td>ユーザー名</td>
                  <td>ユーザー名(カナ)</td>
                  <td>メールアドレス</td>
                  <td>情報ポータル</td>
                  <td>二要素認証</td>
                  <td v-if="data.belongInfo.role == role.role_hospital">CPAP患者レポート</td>
                  <td>編集</td>
                </tr>
                <template v-for="(userInfo, index) in data.usersInfo">
                  <tr :key="index">
                    <td>{{ userInfo.id }}</td>
                    <td>{{ userInfo.familyName }} {{ userInfo.firstName }}</td>
                    <td>{{ userInfo.familyNameKana }} {{ userInfo.firstNameKana }}</td>
                    <td>{{ userInfo.mail }}</td>
                    <td><b-button style="width:27px; height:20px; border:none;color:darkorange" @click="editUser(index,true)">表示</b-button></td>
                    <td><b-checkbox v-model="userInfo.passPhrase" disabled></b-checkbox></td>
                    <td v-if="data.belongInfo.role == role.role_hospital"><b-checkbox v-model="userInfo.isPDashboard" disabled></b-checkbox></td>
                    <td><b-button style="width:27px; height:20px; border:none;" icon-left="pencil-outline" @click="editUser(index,false)"></b-button></td>
                  </tr>
                </template>
              </table>
            </div>
            <div class="card-content margin-top" style="margin-top:20px;">
              <span style="font-size:20px;">利用サービス<span class="requireBrunch"></span></span>
              <table class="service-area">
                <tr></tr>
                <tr>
                  <th></th>
                  <td>
                      <b-checkbox class="columnCheckBox" v-model="useHst" @input="changeCheckBox()" >HST（睡眠検査機器配送サービス）</b-checkbox>
                      <b-checkbox class="columnCheckBox" v-model="usePsg" @input="changeCheckBox()" >PSG解析</b-checkbox>
                      <b-checkbox class="columnCheckBox" v-model="useKenshin" @input="changeCheckBox()" >企業検診</b-checkbox>
                      <b-checkbox class="columnCheckBox" v-model="useHolter" @input="changeCheckBox()" >ホルター心電図配送サービス</b-checkbox>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <b-checkbox class="columnCheckBox" v-model="useCPAP" @input="changeCheckBox()" >CPAP指示書登録サービス</b-checkbox>
                    <b-checkbox class="columnCheckBox" :value="true" disabled >ケアオーケストレーター</b-checkbox>
                  </td>
                </tr>
                <tr v-if="data.belongInfo.role == role.role_hospital">
                  <th></th>
                  <td>
                    <b-checkbox class="columnCheckBox" v-model="useInspectionReport" @input="changeCheckBox()" >呼吸点検報告書</b-checkbox>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td><span>※選択したサービスが組織に属する全ユーザーのホーム画面に表示されます。</span></td>
                </tr>
                <tr>
                  <th></th>
                  <td>※「CPAP患者レポート」はユーザーごとに「ユーザー情報」欄で設定をお願いいたします。</td>
                </tr>
              </table>
            </div>
            <div v-if="useHst && data.belongInfo.role == role.role_hospital" class="labelTitle lable" style="margin-top:20px;">HST（睡眠検査機器配送サービス）</div>
            <div v-if="useHst && data.belongInfo.role == role.role_hospital" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.hstSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.hstSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='hst', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('hst')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.hstSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.hstSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='hst', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('hst', index)"></b-button>
                    </td>
                  </tr>
                </template>
                <tr></tr>
                <template v-for="(itemInfo, index) in data.hstItemInfo">
                  <tr :key="index">
                    <th>
                      <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                    </th>
                    <td>
                      品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                      品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                      見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                    </td>
                  </tr>
                </template>
              </table>
            </div>
            <div v-if="usePsg && data.belongInfo.role == role.role_hospital" class="labelTitle lable" style="margin-top:20px;">PSG解析</div>
            <div v-if="usePsg && data.belongInfo.role == role.role_hospital" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.psgSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.psgSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='psg', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('psg')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.psgSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.psgSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='psg', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('psg', index)"></b-button>
                    </td>
                  </tr>
                </template>
                <tr></tr>
                <template v-for="(itemInfo, index) in data.psgItemInfo">
                  <tr :key="index">
                    <th>
                      <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                    </th>
                    <td>
                      品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                      品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                      見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                    </td>
                  </tr>
                </template>
              </table>
            </div>
            <div v-if="useKenshin && data.belongInfo.role == role.role_hospital" class="labelTitle lable" style="margin-top:20px;">企業検診</div>
            <div v-if="useKenshin && data.belongInfo.role == role.role_hospital" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.kenshinSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.kenshinSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='kenshin', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('kenshin')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.kenshinSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.kenshinSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='kenshin', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('kenshin', index)"></b-button>
                    </td>
                  </tr>
                </template>
                <tr></tr>
                <template v-for="(itemInfo, index) in data.kenshinItemInfo">
                  <tr :key="index">
                    <th>
                      <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                    </th>
                    <td>
                      品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                      品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                      見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                    </td>
                  </tr>
                </template>
              </table>
            </div>
            <div v-if="useHolter && data.belongInfo.role == role.role_hospital" class="labelTitle lable" style="margin-top:20px;">ホルター心電図配送サービス</div>
            <div v-if="useHolter && data.belongInfo.role == role.role_hospital" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.holterSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.holterSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='holter', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('holter')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.holterSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.holterSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='holter', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('holter', index)"></b-button>
                    </td>
                  </tr>
                </template>
                <tr></tr>
                <tr v-if="data.belongInfo.role == role.role_hospital">
                  <th>院内貸出<span class="requireBrunch"/></th>
                  <td>
                    <b-checkbox class="columnCheckBox" style="width:100%!important" v-model="data.belongInfo.holterDepositSignedFlg" @input="changeHolterDepositSignedCheckBox()" >顧客とのホルター心電図院内貸出の契約が完了している</b-checkbox>
                    <b-checkbox class="columnCheckBox" :disabled="!data.belongInfo.holterDepositSignedFlg" v-model="data.belongInfo.holterUseDepositFlg" >ホルター心電図院内貸出を実施する</b-checkbox>
                  </td>
                </tr>
                <tr v-if="data.belongInfo.role == role.role_hospital"></tr>
                <tr v-if="data.belongInfo.role == role.role_hospital">
                  <th>判定医<span class="requireBrunch"/></th>
                  <td>
                    <b-checkbox v-if="data.belongInfo.role !== role.role_dealer" class="columnCheckBox" style="width:100%!important" v-model="data.belongInfo.holterJudgmentFlg" :disabled="!isHolterJudgmentReady">ホルター判定医による評価を実施する</b-checkbox>
                  </td>
                </tr>
                <tr></tr>
                <template v-for="(itemInfo, index) in data.holterItemInfo">
                  <tr :key="index">
                    <th>
                      <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                    </th>
                    <td>
                      品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                      品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                      見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                    </td>
                  </tr>
                </template>
              </table>
            </div>
            <div v-if="data.belongInfo.role == role.role_dealer" class="labelTitle lable" style="margin-top:20px;">施設情報</div>
            <div v-if="data.belongInfo.role == role.role_dealer" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当(代表)<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.salesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.salesStaffAddress" disabled/>
                    <b-button  class="is-primary withButton" v-on:click="staffModalActive=true, kindService='-', salesStaffIndex=0" >選択</b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.salesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr></tr>
              </table>
              <keep-alive>
                <div class="facility-area">
                  <dealerFacilitySetting v-model="targetData" ref="dealerFacilitySetting" :is-holter-judgment-ready="isHolterJudgmentReady"></dealerFacilitySetting>
                </div>
              </keep-alive>
            </div>
            <div v-if="useCPAP" class="labelTitle lable" style="margin-top:20px;">CPAP指示書登録サービス</div>
            <div v-if="useCPAP" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>顧客同意<span class="requireBrunch"/></th>
                  <td>
                    <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapSignedFlg">医療機関もしくはディーラーとのCPAP利用契約が完了している</b-checkbox>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>
                    <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapDepositUseFlg" >顧客とのCPAP預託利用の契約が完了している</b-checkbox>
                  </td>
                </tr>
                <template v-if="data.belongInfo.role == role.role_dealer">
                  <tr>
                    <th></th>
                    <td>
                      <div>
                          <b-radio class="td_radio" name="cpapDealerRentalFlg"  v-model="cpapDealerRentalFlg" native-value="false">患者情報を管理する</b-radio>
                          <b-radio class="td_radio" name="cpapDealerRentalFlg"  v-model="cpapDealerRentalFlg" native-value="true">患者情報を管理しない（機器レンタルのみ）</b-radio>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-if="data.belongInfo.role !== role.role_dealer">
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.cpapSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.cpapSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='cpap', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('cpap')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.cpapSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.cpapSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='cpap', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('cpap', index)"></b-button>
                    </td>
                  </tr>
                </template>
                </template>
                <tr></tr>
                <tr>
                  <th>CPAP利用設定<span class="requireBrunch"/></th>
                  <td>
                    請求先コード：<input type="text" disabled style="width:150px;" v-model="data.belongInfo.cpapBillingCode"/>
                    請求先名称：<input type="text" disabled style="width:403px;" v-model="data.belongInfo.cpapBillingName"/>
                    <b-button  class="is-primary withButton" v-on:click="cpapBillingModalActive=true" >請求先選択</b-button>
                    <br>※病院コードと同じ場合は入力不要です。
                  </td>
                </tr>
                <template v-if="data.belongInfo.role == role.role_hospital">
                  <tr></tr>
                  <tr>
                    <th>ディーラーフォロー<span class="requireBrunch"/></th>
                    <td>
                      <b-checkbox class="columnCheckBox" v-model="data.belongInfo.dealerFollowFlg" >医療機関が依頼した際にディーラー担当者へメールを送信する</b-checkbox>
                    </td>
                  </tr>
                  <template v-if="data.belongInfo.dealerFollowFlg">
                      <tr>
                        <th></th>
                        <td>
                          ディーラー担当者メールアドレス：
                          <input type="text" v-model="data.belongInfo.dealerFollowMail" class="validate" style="width:510px;" name="ディーラー担当者メールアドレス"  validate="mail" maxlength="256" id="dealerFollowMail"/>
                          <b-button class="withButton" @click="sendTestDealerFollowMail">テスト送信</b-button>
                        </td>
                      </tr>
                  </template>
                </template>
              </table>
            </div>
            <div class="labelTitle lable" style="margin-top:20px;">ケアオーケストレーター</div>
            <div class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <template v-if="data.belongInfo.role !== role.role_dealer">
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.coSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.coSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='co', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('co')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.coSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.coSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='co', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('co', index)"></b-button>
                    </td>
                  </tr>
                </template>
                </template>
                <tr></tr>
                <tr>
                  <th>ケアオケ利用状況</th>
                  <td>
                    <template v-if="data.belongInfo.coInUse==coUse.notUse">未利用</template>
                    <template v-else-if="data.belongInfo.coInUse==coUse.waitting">申請待ち</template>
                    <template v-else-if="data.belongInfo.coInUse==coUse.inUse">利用中</template>
                    <template v-else-if="data.belongInfo.coInUse==coUse.registed">
                      登録待ち
                      <b-button class="is-primary coImportButton" @click="coImportModalActive=true">施設情報のインポート</b-button>
                    </template>
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="data.belongInfo.role == role.role_hospital && useInspectionReport" class="labelTitle lable" style="margin-top:20px;">呼吸点検報告書</div>
            <div v-if="data.belongInfo.role == role.role_hospital && useInspectionReport" class="card-content margin-top" style="margin-top:-20px;">
              <table>
                <tr></tr>
                <tr>
                  <th>営業担当<span class="requireBrunch"/></th>
                  <td>
                    氏名：<input type="text" style="width:150px;" v-model="data.belongInfo.inspectionReportSalesStaffName" disabled/>
                    メールアドレス：<input type="text" style="width:430px;" v-model="data.belongInfo.inspectionReportSalesStaffAddress" disabled/>
                    <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='inspectionReport', salesStaffIndex=-1" >選択</b-button>
                    <b-button class="is-primary selectButton" icon-left="email-plus-outline" @click="addSalesStaffMail('inspectionReport')"></b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>担当営業所(売上)：
                    <select style="width:250px;" v-model="data.belongInfo.inspectionReportSalesOfficeCode">
                      <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                        {{office.name}}
                      </option>
                    </select>
                  </td>
                </tr>
                <template v-for="(salesStaffInfo, index) in data.inspectionReportSalesStaffsInfo">
                  <template v-if="index==0">
                    <tr :key="index"></tr>
                    <tr :key="index">
                      <th></th>
                      <td><span style="display:inline-block; width:50px;"></span>メール共有先</td>
                    </tr>
                  </template>
                  <tr :key="salesStaffInfo.salesStaffId">
                    <th></th>
                    <td>
                      <span style="display:inline-block; width:50px;"></span>
                      氏名：<input type="text" style="width:150px;" v-model="salesStaffInfo.salesStaffName" disabled/>
                      メールアドレス：<input type="text" style="width:375px;" v-model="salesStaffInfo.salesStaffAddress" disabled/>
                      <b-button class="is-primary selectButton" v-on:click="staffModalActive=true, kindService='inspectionReport', salesStaffIndex=index" >選択</b-button>
                      <b-button class="is-primary selectButton" icon-left="delete-forever-outline" @click="deleteSalesStaffMail('inspectionReport', index)"></b-button>
                    </td>
                  </tr>
                </template>
                <tr></tr>
                <tr>
                  <th><span :class="disabledInspectionReport('requireBrunch')">SMS医療機関情報</span></th>
                  <td>
                    <span :class="disabledInspectionReport()">医療機関コード:</span><input type="text" disabled style="width:150px;" v-model="data.belongInfo.smsHospitalCode"/>
                    <span :class="disabledInspectionReport()">医療機関名称:</span><input type="text" disabled style="width:400px;" v-model="data.belongInfo.smsHospitalName"/>
                    <b-button  class="is-primary withButton" :disabled="this.useInspectionReport ? false : true" v-on:click="smsHospitalModalActive=true" >医療機関選択</b-button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td><span :class="disabledInspectionReport()">※利用サービスに呼吸点検報告書を含む場合は指定してください</span></td>
                </tr>
              </table>
            </div>
          </div>
          <template v-if="data.belongInfo.role != role.role_judgment && data.belongInfo.role != role.role_holter_judgment && data.belongInfo.role != role.role_analysis">
            <template v-if="(data.belongInfo.role==role.role_hospital || data.belongInfo.role==role.role_dealer) && data.userInfo.status==extUserStatus.tempReg && !belongsSelected">
              <div class="card-content margin-top">
                <span v-if="data.userInfo.status == 1" style="font-size: 30px; color:red;">※こちらは本社入力欄です。支店での操作は行わないでください。<br></span>
                <div class="card-content margin-top">
                  <div>
                    <span class="requireHeadOffice"/>
                    <span style="font-size: 20px;">　　　組織情報を検索してください。</span>
                  </div>
                  <div style="margin-top:15px;">
                      <span>得意先コード：</span><input type="text" style="width:300px;" v-model="searchCondition.belongsCustomerCode"/>
                      <span style="margin-left:10px;">組織名：</span><input type="text" style="width:300px;" v-model="searchCondition.belongsName"/>
                  </div>
                  <div style="margin-top:15px;">
                    <b-button  class="is-primary withButton" v-on:click="searchBelongList" >組織検索</b-button>
                  </div>
                  <div class="result-area" style="margin-left:10px;margin-right: 10px;">
                    <b-table v-if="belongsList.length > 0"
                      id="belongListTable"
                      :data="belongsList"
                      paginated
                      per-page="20"
                      pagination-position="both"
                      aria-next-label="Next page"
                      aria-previous-label="Previous page"
                      aria-page-label="Page"
                      aria-current-label="Current page"
                    >
                      <template slot-scope="props">
                        <b-table-column field="customerId" label="" width="20" centered>
                          <div>
                            <b-radio class="customRadio" name="radioItem" v-model="selectedNewBelongs" :native-value="props.row"></b-radio>
                          </div>
                        </b-table-column>
                        <b-table-column field="customerId" label="得意先コード" width="150" centered>{{props.row.customerId }}</b-table-column>
                        <b-table-column field="customerName" label="組織名" width="500" >{{props.row.medicalInstitutionFullName}}</b-table-column>
                        <b-table-column field="branchCode" label="担当支店" width="170" >{{props.row.branchCode | branchFilter(branchOfficeMaster)}}</b-table-column>
                        <b-table-column field="address" label="住所"  width="600" >{{props.row.address}}</b-table-column>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="margin-top">
                  <b-button  class="is-primary belongsSlectedBtn" v-on:click="changeBelongsId" :disabled="selectedNewBelongs==null" >選択した組織情報を使用して登録を続ける</b-button>
                  <span style="padding-left:10px;padding-right:10px;"/>
                  <b-button  class="is-primary belongsSlectedBtn" v-on:click="noChangeBelongsId" >リストに存在しないため、新しい組織として登録する</b-button>
                </div>

              </div>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.dummy">
              <div class="card-content margin-top">
                <span style="font-size:20px;">システム連携情報</span>
                <div style="height:13px;"></div>
                <table>
                  <tr><th> 得意先情報<span class="requireHeadOffice"/></th>
                    <td>
                      得意先ID:<input type="text" disabled style="width:150px;" v-model="data.belongInfo.customerId"/>
                      得意先名称:<input type="text" disabled style="width:460px;" v-model="data.belongInfo.customerName"/>
                      <b-button  class="is-primary withButton" v-on:click="customerModalActive=true" >得意先選択</b-button>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>担当支店:
                        <select style="width:250px;" v-model="data.belongInfo.branchStore">
                          <option v-for="branch of branchOfficeMaster" :value="branch.code" :key="'d' + branch.code">
                            {{branch.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                  <tr/>
                  <tr><th>営業担当<span class="requireBrunch"/></th>
                    <td>
                      担当者名:<input type="text" style="width:150px;" v-model="data.belongInfo.salesStaffName" disabled/>
                      メールアドレス:<input type="text" style="width:430px;" v-model="data.belongInfo.salesStaffAddress" disabled/>
                      <b-button  class="is-primary withButton" v-on:click="staffModalActive=true, kindService='-', salesStaffIndex=0" >担当者選択</b-button>
                    </td>
                  </tr>
                  <tr><th> </th>
                    <td>担当営業所(売上):
                        <select style="width:250px;" v-model="data.belongInfo.salesOfficeCode">
                          <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                            {{office.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                    <template v-if="useCPAP">
                    <tr></tr>
                      <tr>
                        <th>CPAP利用設定<span class="requireBrunch"/></th>
                        <td>
                          請求先コード:<input type="text" disabled style="width:150px;" v-model="data.belongInfo.cpapBillingCode"/>
                          請求先名称:<input type="text" disabled style="width:430px;" v-model="data.belongInfo.cpapBillingName"/>
                          <b-button  class="is-primary withButton" v-on:click="cpapBillingModalActive=true" >請求先選択</b-button>
                          <br>※得意先IDと同じ場合は入力不要です。
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapSignedFlg " >医療機関もしくはディーラーとのCPAP利用契約が完了している</b-checkbox>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            使用明細確認者メールアドレス:
                            <input type="text" v-model="data.belongInfo.cpapUsageDetailMail" class="validate" id="cpapUsageDetailMail" style="width:540px;" name="使用明細確認者メールアドレス" disabled validate="mail" maxlength="256"/>
                            <b-button class="withButton" @click="sendTestCpapUsageDetailMail" disabled>テスト送信</b-button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          <div>
                            <b-checkbox class="columnCheckBox" v-model="data.belongInfo.cpapUsageDetailBehalf" >使用明細を支店から発行（FAX・持参等）する(使用明細確認を支店で代理する)</b-checkbox>
                          </div>
                        </td>
                      </tr>
                    </template>
                </table>
              </div>
            </template>
            <template v-else-if="data.belongInfo.role == role.role_corporation || data.belongInfo.role == role.role_accommodations">
              <div class="card-content margin-top">
                <span style="font-size:20px;">システム連携情報</span>
                <div style="height:13px;"></div>
                <table>
                  <tr><th> 得意先情報<span class="requireHeadOffice"/></th>
                    <td>
                      得意先ID:<input type="text" disabled style="width:150px;" v-model="data.belongInfo.customerId"/>
                      得意先名称:<input type="text" disabled style="width:460px;" v-model="data.belongInfo.customerName"/>
                      <b-button  class="is-primary withButton" v-on:click="customerModalActive=true" >得意先選択</b-button>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>担当支店:
                        <select style="width:250px;" v-model="data.belongInfo.branchStore">
                          <option v-for="branch of branchOfficeMaster" :value="branch.code" :key="'d' + branch.code">
                            {{branch.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                  <tr/>
                  <tr><th>営業担当<span class="requireBrunch"/></th>
                    <td>
                      担当者名:<input type="text" style="width:150px;" v-model="data.belongInfo.salesStaffName" disabled/>
                      メールアドレス:<input type="text" style="width:430px;" v-model="data.belongInfo.salesStaffAddress" disabled/>
                      <b-button  class="is-primary withButton" v-on:click="staffModalActive=true, kindService='-', salesStaffIndex=0" >担当者選択</b-button>
                    </td>
                  </tr>
                  <tr><th> </th>
                    <td>担当営業所(売上):
                        <select style="width:250px;" v-model="data.belongInfo.salesOfficeCode">
                          <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                            {{office.name}}
                          </option>
                        </select>
                    </td>
                  </tr>
                  <tr/>
                  <template v-for="(itemInfo, index) in data.inspectionItemInfo">
                    <tr :key="index">
                      <th>
                        <template v-if="index==0">見積り情報<span class="requireBrunch"/></template>
                        <template v-if="index==1 && data.belongInfo.role==role.role_dealer">
                            <b-button  class="is-primary withButton" @click="goFacilitySetting" >施設別設定</b-button>
                            <span v-if="data.facilityError" class="facilityError"/>
                        </template>
                      </th>
                      <td>
                        品目コード：<input type="text" style="width:100px;" v-model="itemInfo.itemCode" disabled/>
                        品目名：<input type="text" style="width:410px;" v-model="itemInfo.itemName" disabled/>
                        見積りコード：<input type="text" style="width:150px;" v-model="itemInfo.estimateCode" maxlength="20"/>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </template>
          </template>
          <div v-if="data.userInfo.status!=extUserStatus.dummy && data.belongInfo.role != role.role_hospital && data.belongInfo.role != role.role_dealer" class="card-content margin-top">
            <span style="font-size:20px;">ポータル公開設定情報</span>
            <div style="height:13px;"></div>
              <th style="width: 220px">
                情報ポータル公開範囲<span class="requireBrunch" />
              </th>
              <td>
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledNotice"
                  disabled
                  >お知らせ</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledGuidance"
                  :disabled="isDisablePortalItem()"
                  >ご案内</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledEvent"
                  :disabled="isDisablePortalItem()"
                  >学会・イベント情報</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledNews"
                  >ニュース</b-checkbox
                >
                <b-checkbox
                  class="columnCheckBox"
                  v-model="isEnabledProduct"
                  :disabled="isDisablePortalItem()"
                  >製品情報</b-checkbox
                >
              </td>
            </tr>
            <tr>
              <th style="width: 220px">
                定期メール送信設定<span class="requireBrunch" />
              </th>
              <td>
                <b-checkbox
                  class="columnCheckBox"
                  @input="changeCheckBox()"
                  v-model="isEnabledMail"
                  >定期メールを送信する</b-checkbox
                >
              </td>
            </tr>
          </div>
          <div class="searchButton-area" style="margin-bottom:10px;">
            <template v-if="data.userInfo.status==extUserStatus.registed">
              <!--本登録中 -->
              <b-button class="is-primary" v-on:click="update">更新</b-button>
              <!-- <b-button v-if="roleId==role.role_headOffice || roleId==role.role_admin" class="is-primary" v-on:click="del">削除</b-button> -->
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.brunchReview">
              <!--支店回送中 -->
              <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              <!-- <b-button v-if="roleId==role.role_headOffice || roleId==role.role_admin" class="is-primary" v-on:click="del">削除</b-button> -->
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.tempReg">
              <!--仮登録中 -->
              <template v-if="data.belongInfo.role==role.role_hospital || data.belongInfo.role==role.role_dealer">
                <template v-if="belongsSelected">
                  <template v-if="roleId==role.role_headOffice || roleId==role.role_admin">
                    <b-button class="is-primary" v-on:click="sendSalesOffice">担当部署へ回送</b-button>
                  </template>
                  <template v-if="roleId==role.role_admin">
                    <b-button class="is-primary" v-on:click="regist">本登録</b-button>
                  </template>
                </template>
              </template>
              <template v-else-if="data.belongInfo.role==role.role_corporation">
                <b-button class="is-primary" v-on:click="sendSalesOffice">担当部署へ回送</b-button>
              </template>
              <template v-else>
                <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              </template>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.dummy">
              <!--暫定 -->
              <b-button class="is-primary" v-on:click="updateCheck">更新</b-button>
              <template v-if="roleId==role.role_headOffice || roleId==role.role_admin">
                <b-button class="is-primary" v-on:click="dummyRegist">本登録にする</b-button>
                <b-button class="is-primary dummy" v-on:click="dummyChangeRegist">本登録ユーザーに紐づける</b-button>
              </template>
            </template>
            <template v-else-if="data.userInfo.status==extUserStatus.addRequest">
              <!--追加依頼中 -->
              <template v-if="roleId==role.role_headOffice || roleId==role.role_admin">
                <!--本社、管理者ユーザのみ本登録可能 -->
                <b-button class="is-primary" v-on:click="regist">本登録</b-button>
              </template>
              <!-- <b-button class="is-primary" v-on:click="del">削除</b-button> -->
            </template>
            <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="customerModalActive" has-modal-card>
      <customerModal @select="setCustomer"></customerModal>
    </b-modal>
    <b-modal :active.sync="cpapBillingModalActive" has-modal-card>
      <customerModal @select="setCpapBilling" :allowBlank="true"></customerModal>
    </b-modal>
    <b-modal :active.sync="staffModalActive" has-modal-card :destroy-on-hide="false">
      <staffModal @select="setStaff" :selectRole="[]" :kindService="kindService" :index="salesStaffIndex"></staffModal>
    </b-modal>
    <b-modal :active.sync="billModalActive" has-modal-card>
      <customerModal @select="setBill" :allowBlank="true"></customerModal>
    </b-modal>
    <b-modal :active.sync="coImportModalActive" has-modal-card>
      <coImportModal @reload="reload" :isDealer="data.belongInfo.role == role.role_dealer" :belongId="data.belongInfo.id"></coImportModal>
    </b-modal>
    <b-modal :active.sync="smsHospitalModalActive" has-modal-card>
      <smsHospitalModal @select="setSmsHospital"></smsHospitalModal>
    </b-modal>
    <b-modal :active.sync="dummyRegistModalActive">
      <dummyRegistModal @select="dummySendSalesOffice" :belongs="data.belongInfo"></dummyRegistModal>
    </b-modal>
    <b-modal :active.sync="dummyChangeModalActive">
      <dummyChangeModal :dummyInfo="data"></dummyChangeModal>
    </b-modal>
    <b-modal :active.sync="userAddModalActive" has-modal-card>
      <userAddModal @select="setUserInfo" @pDushLastConfirm="doPDushLastConfirm" :userRole="data.belongInfo.role" :userData="userData" :editFlag="editFlag" :initialpDashboardInfo="initialpDashboardInfo"></userAddModal>
    </b-modal>
    <b-modal :active.sync="portalConfirmModalActive" has-modal-card>
      <portalConfirmModal :portalSettingInfo="portalSettingInfo"></portalConfirmModal>
    </b-modal>
  </div>
</template>

<script>
import {
  role,
  service,
  extUserStatus,
  coUse,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
import CustomerSelectModal from "@/components/mock/philips/common/CustomerSelectModal";
import StaffSelectModal from "@/components/mock/philips/common/StaffSelectModal";
import coImportModal from "@/components/mock/philips/common/CoImportModal";
import SmsHospitalSelectModal from "@/components/mock/philips/common/SmsHospitalSelectModal";
import DummyRegistModal from "@/components/mock/philips/common/DummyRegistModal";
import DummyChangeModal from "@/components/mock/philips/common/DummyChangeModal";
import {pDashboardServiceName} from "@/components/mock/base/const.js";
import DealerFacilitySetting from "@/components/mock/philips/master/user/DealerFacilitySetting";
import UserAddModal from "@/components/mock/philips/common/UserAddModal";
import PortalConfirmModal from "@/components/mock/philips/common/PortalConfirmModal";

export default {
  name: "ExternalUserEdit",
  methods: {
    unLock: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.userUnlockPOST({
            body:{
              userId: _this.data.userInfo.id
            }
          });
        },
        async function(result){
          _this.showSuccess(result);
          //再読み込み
          await _this.getExternalUserDetail();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
    back: function() {
      if(this.from =='control'){
        this.$router.push({
          name: "ExternalUserControlSearch",
          params: {searchConditions: this.searchConditions}
        });
      } else {
        this.$router.push({
          name: "ExternalUserSearch",
          params: {searchConditions: this.searchConditions}
        });
      }
    },
    sendTestSMS: function(){
        if(this.data.userInfo.passPhrasePhoneNumber != ""){
            var checkFields = [document.getElementById("passphraseSendNo")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                    passphraseSendMail:"",
                    passphraseSendNo:this.data.userInfo.passPhrasePhoneNumber
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("パスフレーズ送信先(携帯番号)を入力してください。")
        }
    },
    sendTestMail: function(){
        if(this.data.userInfo.passPhraseMail != ""){
            var checkFields = [document.getElementById("passphraseSendMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.userInfo.passPhraseMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("パスフレーズ送信先(Eメールアドレス)を入力してください。")
        }
    },
    sendTestPublicAddressMail: function(){
        if(this.data.belongInfo.publicMail != ""){
            var checkFields = [document.getElementById("publicMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.publicMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
          this.showErrorMessage("連絡先メールアドレスを入力してください。")
        }
    },
    sendTestCpapUsageDetailMail: function(){
        if(this.data.belongInfo.cpapUsageDetailMail != ""){
            var checkFields = [document.getElementById("cpapUsageDetailMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.cpapUsageDetailMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("使用明細確認者メールアドレスを入力してください。")
        }
    },
    sendTestDealerFollowMail: function(){
        if(this.data.belongInfo.dealerFollowMail != ""){
            var checkFields = [document.getElementById("dealerFollowMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                  passphraseSendMail:this.data.belongInfo.dealerFollowMail,
                  passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("ディーラー担当者メールアドレスを入力してください。")
        }
    },
    sendTest: function(param){
      try {
          this.$store.dispatch("sendTest", {
            token: this.token,
            contactAddress: param.passphraseSendMail,
            contactPhoneNumber: param.passphraseSendNo
          }).then(result => {
              console.log(result);
              if(result != null && result.status === 200 ) {
                  this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。") 
              } else {
                  this.showErrorMessage(result.message) 
              }
              this.isActive = true;
          }).catch(error => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。")
          });
      } catch(err){
          console.log(error);
          this.showErrorMessage("予期しないエラーが発生しました。")
      }
    },
    createBody: function(){
      let userInfo = {
                id: this.data.userInfo.id ? this.data.userInfo.id:0,
                familyName: this.data.userInfo.familyName ? this.data.userInfo.familyName:"",
                firstName: this.data.userInfo.firstName ? this.data.userInfo.firstName:"",
                familyNameKana: this.data.userInfo.familyNameKana ? this.data.userInfo.familyNameKana:"",
                firstNameKana: this.data.userInfo.firstNameKana ? this.data.userInfo.firstNameKana:"",
                mail: this.data.userInfo.mail ? this.data.userInfo.mail:"",
                passPhrase: this.data.userInfo.passPhrase ? this.data.userInfo.passPhrase:false,
                passPhrasePhoneNumber: this.data.userInfo.passPhrasePhoneNumber ? this.data.userInfo.passPhrasePhoneNumber:"",
                passPhraseMail: this.data.userInfo.passPhraseMail ? this.data.userInfo.passPhraseMail:"",
                mailError: this.data.userInfo.mailError ? this.data.userInfo.mailError:false,
                lock: this.data.userInfo.lock ? this.data.userInfo.lock:false,
                status: this.data.userInfo.status ? this.data.userInfo.status:"0",
              };
      // 未利用サービスの項目は更新しない
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.hst)){
        this.data.belongInfo.hstSalesStaffId = null;
        this.data.belongInfo.hstSalesOfficeCode = null;
        this.data.hstSalesStaffsInfo = [];
        for(let item of this.data.hstItemInfo){
          item.estimateCode = "";
        }
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.psg)){
        this.data.belongInfo.psgSalesStaffId = null;
        this.data.belongInfo.psgSalesOfficeCode = null;
        this.data.psgSalesStaffsInfo = [];
        for(let item of this.data.psgItemInfo){
          item.estimateCode = "";
        }
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.kenshin)){
        this.data.belongInfo.kenshinSalesStaffId = null;
        this.data.belongInfo.kenshinSalesOfficeCode = null;
        this.data.kenshinSalesStaffsInfo = [];
        for(let item of this.data.kenshinItemInfo){
          item.estimateCode = "";
        }
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.holter)){
        this.data.belongInfo.holterSalesStaffId = null;
        this.data.belongInfo.holterSalesOfficeCode = null;
        this.data.holterSalesStaffsInfo = [];
        this.data.belongInfo.holterDepositSignedFlg = false;
        this.data.belongInfo.holterUseDepositFlg =  false;
        this.data.belongInfo.holterJudgmentFlg =  false;
        for(let item of this.data.holterItemInfo){
          item.estimateCode = "";
        }
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.cpap)){
        this.data.belongInfo.cpapSalesStaffId = null;
        this.data.belongInfo.cpapSalesOfficeCode = null;
        this.data.cpapSalesStaffsInfo = [];
        this.data.belongInfo.cpapSignedFlg = false;
        this.data.belongInfo.cpapDepositUseFlg = false;
        this.cpapDealerRentalFlg = false;
        this.data.belongInfo.cpapBillingCode = '';
        this.data.belongInfo.dealerFollowFlg = false;
        this.data.belongInfo.dealerFollowMail = '';
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.inspection_report)){
        this.data.belongInfo.inspectionReportSalesStaffId = null;
        this.data.belongInfo.inspectionReportSalesOfficeCode = null;
        this.data.inspectionReportSalesStaffsInfo = [];
        this.data.belongInfo.smsHospitalCode = '';
      }
      if(!this.isEnableService(this.data.belongInfo.useService, this.service.inspection_report)){
        this.data.belongInfo.inspectionReportSalesStaffId = null;
        this.data.belongInfo.inspectionReportSalesOfficeCode = null;
        this.data.inspectionReportSalesStaffsInfo = [];
        this.data.belongInfo.smsHospitalCode = '';
      }

      let belongInfo = {
                id: this.data.belongInfo.id ? this.data.belongInfo.id:0,
                role: this.data.belongInfo.role ? this.data.belongInfo.role:0,
                medicalInstitutionName: this.data.belongInfo.medicalInstitutionName ? this.data.belongInfo.medicalInstitutionName:"",
                departmentName:  this.data.belongInfo.departmentName ? this.data.belongInfo.departmentName:"",
                customerPostCode:  this.data.belongInfo.customerPostCode ? this.data.belongInfo.customerPostCode:"",
                prefecture:  this.data.belongInfo.prefecture ? this.data.belongInfo.prefecture:"",
                city:  this.data.belongInfo.city ? this.data.belongInfo.city:"",
                customerAddress1:  this.data.belongInfo.customerAddress1 ? this.data.belongInfo.customerAddress1:"",
                customerAddress2:  this.data.belongInfo.customerAddress2 ? this.data.belongInfo.customerAddress2:"",
                phoneNumber:  this.data.belongInfo.phoneNumber ? this.data.belongInfo.phoneNumber:"",
                mail:  this.data.belongInfo.mail ? this.data.belongInfo.mail:"",
                customerId:  this.data.belongInfo.customerId ? this.data.belongInfo.customerId:"",
                customerName:  this.data.belongInfo.customerName ? this.data.belongInfo.customerName:"",
                branchStore:  this.data.belongInfo.branchStore ? this.data.belongInfo.branchStore:"",
                salesStaffId:  this.data.belongInfo.salesStaffId ? this.data.belongInfo.salesStaffId:0,
                salesStaffName:  this.data.belongInfo.salesStaffName ? this.data.belongInfo.salesStaffName:"",
                salesStaffAddress:  this.data.belongInfo.salesStaffAddress ? this.data.belongInfo.salesStaffAddress:"",
                salesOfficeCode:  this.data.belongInfo.salesOfficeCode ? this.data.belongInfo.salesOfficeCode:"",
                billingId:  this.data.belongInfo.billingId ? this.data.belongInfo.billingId:"",
                useService:  this.data.belongInfo.useService ? this.data.belongInfo.useService:0,
                publicMail:  this.data.belongInfo.publicMail ? this.data.belongInfo.publicMail:"",
                agreedInfoDisclosure:  this.data.belongInfo.agreedInfoDisclosure ? this.data.belongInfo.agreedInfoDisclosure:false,
                facilityError:  this.data.belongInfo.facilityError ? this.data.belongInfo.facilityError:false,
                note:  this.data.belongInfo.note ? this.data.belongInfo.note : "",
                dealerFollowFlg:  this.data.belongInfo.dealerFollowFlg ? this.data.belongInfo.dealerFollowFlg:false,
                dealerFollowMail: this.data.belongInfo.dealerFollowMail ? this.data.belongInfo.dealerFollowMail : "",
                cpapSignedFlg: this.data.belongInfo.cpapSignedFlg ? this.data.belongInfo.cpapSignedFlg:false,
                cpapDealerRentalFlg: this.cpapDealerRentalFlg != null ? this.cpapDealerRentalFlg == "true" :false,
                cpapUsageDetailMail:  this.data.belongInfo.cpapUsageDetailMail ? this.data.belongInfo.cpapUsageDetailMail:"",
                cpapUsageDetailBehalf: this.data.belongInfo.cpapUsageDetailBehalf ? this.data.belongInfo.cpapUsageDetailBehalf:false,
                cpapDepositUseFlg: this.data.belongInfo.cpapDepositUseFlg ? this.data.belongInfo.cpapDepositUseFlg:false,
                cpapBillingCode:  this.data.belongInfo.cpapBillingCode ? this.data.belongInfo.cpapBillingCode:"",
                coUseStatus: this.data.belongInfo.coInUse ? this.data.belongInfo.coInUse:0,
                holterDepositSignedFlg: this.data.belongInfo.holterDepositSignedFlg ? this.data.belongInfo.holterDepositSignedFlg:false,
                holterUseDepositFlg: this.data.belongInfo.holterUseDepositFlg ? this.data.belongInfo.holterUseDepositFlg:false,
                smsHospitalCode: this.useInspectionReport && this.data.belongInfo.smsHospitalCode ? this.data.belongInfo.smsHospitalCode:"",
                takeupStatus: this.data.belongInfo.takeupStatus ? this.data.belongInfo.takeupStatus:0,
                holterJudgmentFlg: this.data.belongInfo.holterJudgmentFlg ? this.data.belongInfo.holterJudgmentFlg:false,
                hstSalesStaffId: this.data.belongInfo.hstSalesStaffId ? this.data.belongInfo.hstSalesStaffId:"",
                hstSalesStaffName: this.data.belongInfo.hstSalesStaffName ? this.data.belongInfo.hstSalesStaffName:"",
                hstSalesStaffAddress: this.data.belongInfo.hstSalesStaffAddress ? this.data.belongInfo.hstSalesStaffAddress:"",
                hstSalesOfficeCode: this.data.belongInfo.hstSalesOfficeCode ? this.data.belongInfo.hstSalesOfficeCode:"",
                psgSalesStaffId: this.data.belongInfo.psgSalesStaffId ? this.data.belongInfo.psgSalesStaffId:"",
                psgSalesStaffName: this.data.belongInfo.psgSalesStaffName ? this.data.belongInfo.psgSalesStaffName:"",
                psgSalesStaffAddress: this.data.belongInfo.psgSalesStaffAddress ? this.data.belongInfo.psgSalesStaffAddress:"",
                psgSalesOfficeCode: this.data.belongInfo.psgSalesOfficeCode ? this.data.belongInfo.psgSalesOfficeCode:"",
                kenshinSalesStaffId: this.data.belongInfo.kenshinSalesStaffId ? this.data.belongInfo.kenshinSalesStaffId:"",
                kenshinSalesStaffName: this.data.belongInfo.kenshinSalesStaffName ? this.data.belongInfo.kenshinSalesStaffName:"",
                kenshinSalesStaffAddress: this.data.belongInfo.kenshinSalesStaffAddress ? this.data.belongInfo.kenshinSalesStaffAddress:"",
                kenshinSalesOfficeCode: this.data.belongInfo.kenshinSalesOfficeCode ? this.data.belongInfo.kenshinSalesOfficeCode:"",
                holterSalesStaffId: this.data.belongInfo.holterSalesStaffId ? this.data.belongInfo.holterSalesStaffId:"",
                holterSalesStaffName: this.data.belongInfo.holterSalesStaffName ? this.data.belongInfo.holterSalesStaffName:"",
                holterSalesStaffAddress: this.data.belongInfo.holterSalesStaffAddress ? this.data.belongInfo.holterSalesStaffAddress:"",
                holterSalesOfficeCode: this.data.belongInfo.holterSalesOfficeCode ? this.data.belongInfo.holterSalesOfficeCode:"",
                cpapSalesStaffId: this.data.belongInfo.cpapSalesStaffId ? this.data.belongInfo.cpapSalesStaffId:"",
                cpapSalesStaffName: this.data.belongInfo.cpapSalesStaffName ? this.data.belongInfo.cpapSalesStaffName:"",
                cpapSalesStaffAddress: this.data.belongInfo.cpapSalesStaffAddress ? this.data.belongInfo.cpapSalesStaffAddress:"",
                cpapSalesOfficeCode: this.data.belongInfo.cpapSalesOfficeCode ? this.data.belongInfo.cpapSalesOfficeCode:"",
                coSalesStaffId: this.data.belongInfo.coSalesStaffId ? this.data.belongInfo.coSalesStaffId:"",
                coSalesStaffName: this.data.belongInfo.coSalesStaffName ? this.data.belongInfo.coSalesStaffName:"",
                coSalesStaffAddress: this.data.belongInfo.coSalesStaffAddress ? this.data.belongInfo.coSalesStaffAddress:"",
                coSalesOfficeCode: this.data.belongInfo.coSalesOfficeCode ? this.data.belongInfo.coSalesOfficeCode:"",
                inspectionReportSalesStaffId: this.data.belongInfo.inspectionReportSalesStaffId ? this.data.belongInfo.inspectionReportSalesStaffId:"",
                inspectionReportSalesStaffName: this.data.belongInfo.inspectionReportSalesStaffName ? this.data.belongInfo.inspectionReportSalesStaffName:"",
                inspectionReportSalesStaffAddress: this.data.belongInfo.inspectionReportSalesStaffAddress ? this.data.belongInfo.inspectionReportSalesStaffAddress:"",
                inspectionReportSalesOfficeCode: this.data.belongInfo.inspectionReportSalesOfficeCode ? this.data.belongInfo.inspectionReportSalesOfficeCode:"",
              };
      let inspectionItemInfo = [];
      for(let inspectionItem of this.data.inspectionItemInfo){
        inspectionItemInfo.push(
          {
            estimateId: inspectionItem.estimateId ? inspectionItem.estimateId : 0,
            itemCode: inspectionItem.itemCode ? inspectionItem.itemCode : "",
            itemName: inspectionItem.itemName ? inspectionItem.itemName : "",
            estimateCode: inspectionItem.estimateCode ? inspectionItem.estimateCode : "",
          }
        );
      }
      let portalPublicationRangeSettingInfo = {
        isEnabledNotice: this.isEnabledNotice,
        isEnabledGuidance: this.isEnabledGuidance,
        isEnabledEvent: this.isEnabledEvent,
        isEnabledNews: this.isEnabledNews,
        isEnabledProduct: this.isEnabledProduct,
        isEnabledMail: this.isEnabledMail,
      };
      let pDashboardSettingInfo = {
        usePDashboard: this.usePDashboard,
        pDashboardSignedFlag: this.pDashboardSignedFlag,
        integratorUser: this.data.pDashboardInfo.pDashboardSettingInfo.integratorUser,
        integratorKey: this.data.pDashboardInfo.pDashboardSettingInfo.integratorKey,
        orgId: this.data.pDashboardInfo.pDashboardSettingInfo.orgId,
        displayConfirmationFlag: this.isDoneDisplayConfirmation,
      }

      // ユーザー情報
      let usersInfo = [];
      for(let userInfo of this.data.usersInfo){
        usersInfo.push(
          {
            id: userInfo.id ? userInfo.id:0,
            familyName: userInfo.familyName ? userInfo.familyName:"",
            firstName: userInfo.firstName ? userInfo.firstName:"",
            familyNameKana: userInfo.familyNameKana ? userInfo.familyNameKana:"",
            firstNameKana: userInfo.firstNameKana ? userInfo.firstNameKana:"",
            mail: userInfo.mail ? userInfo.mail:"",
            passPhrase: userInfo.passPhrase ? userInfo.passPhrase:false,
            passPhrasePhoneNumber: userInfo.passPhrasePhoneNumber ? userInfo.passPhrasePhoneNumber:"",
            passPhraseMail: userInfo.passPhraseMail ? userInfo.passPhraseMail:"",
            mailError: userInfo.mailError ? true : false,
            lock: userInfo.lock ? userInfo.lock:false,
            status: userInfo.status ? userInfo.status + "":"0",
            isEnabledNotice: userInfo.isEnabledNotice ? userInfo.isEnabledNotice:false,
            isEnabledGuidance: userInfo.isEnabledGuidance ? userInfo.isEnabledGuidance:false,
            isEnabledEvent: userInfo.isEnabledEvent ? userInfo.isEnabledEvent:false,
            isEnabledNews: userInfo.isEnabledNews ? userInfo.isEnabledNews:false,
            isEnabledProduct: userInfo.isEnabledProduct ? userInfo.isEnabledProduct:false,
            isEnabledMail: userInfo.isEnabledMail ? userInfo.isEnabledMail:false,
            usePDashboard: userInfo.isPDashboard ? userInfo.isPDashboard:false,
            pDashboardSignedFlag: userInfo.pDashboardSignedFlag ? userInfo.pDashboardSignedFlag:false,
            integratorUser: userInfo.integratorUser ? userInfo.integratorUser:"",
            integratorKey: userInfo.integratorKey ? userInfo.integratorKey:"",
            orgId: userInfo.orgId ? userInfo.orgId:"",
            displayConfirmationFlag: userInfo.displayConfirmationFlag ? userInfo.displayConfirmationFlag:false,
          }
        )
      }

      // メール共有先情報
      let hstSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.hstSalesStaffsInfo){
        hstSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let psgSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.psgSalesStaffsInfo){
        psgSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let kenshinSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.kenshinSalesStaffsInfo){
        kenshinSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let holterSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.holterSalesStaffsInfo){
        holterSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let cpapSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.cpapSalesStaffsInfo){
        cpapSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let coSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.coSalesStaffsInfo){
        coSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }
      let inspectionReportSalesStaffsInfo = [];
      for(let salesStaffInfo of this.data.inspectionReportSalesStaffsInfo){
        inspectionReportSalesStaffsInfo.push(
          {
            salesStaffId: salesStaffInfo.salesStaffId ? salesStaffInfo.salesStaffId:0,
            salesStaffName: salesStaffInfo.salesStaffName ? salesStaffInfo.salesStaffName:"",
            salesStaffAddress: salesStaffInfo.salesStaffAddress ? salesStaffInfo.salesStaffAddress:"",
          }
        );
      }

      // 見積り情報
      let hstItemInfo = [];
      for(let hstItem of this.data.hstItemInfo){
        hstItemInfo.push(
          {
            estimateId: hstItem.estimateId ? hstItem.estimateId : 0,
            itemCode: hstItem.itemCode ? hstItem.itemCode : "",
            itemName: hstItem.itemName ? hstItem.itemName : "",
            estimateCode: hstItem.estimateCode ? hstItem.estimateCode : "",
          }
        );
      }
      let psgItemInfo = [];
      for(let psgItem of this.data.psgItemInfo){
        psgItemInfo.push(
          {
            estimateId: psgItem.estimateId ? psgItem.estimateId : 0,
            itemCode: psgItem.itemCode ? psgItem.itemCode : "",
            itemName: psgItem.itemName ? psgItem.itemName : "",
            estimateCode: psgItem.estimateCode ? psgItem.estimateCode : "",
          }
        );
      }
      let kenshinItemInfo = [];
      for(let kenshinItem of this.data.kenshinItemInfo){
        kenshinItemInfo.push(
          {
            estimateId: kenshinItem.estimateId ? kenshinItem.estimateId : 0,
            itemCode: kenshinItem.itemCode ? kenshinItem.itemCode : "",
            itemName: kenshinItem.itemName ? kenshinItem.itemName : "",
            estimateCode: kenshinItem.estimateCode ? kenshinItem.estimateCode : "",
          }
        );
      }
      let holterItemInfo = [];
      for(let holterItem of this.data.holterItemInfo){
        holterItemInfo.push(
          {
            estimateId: holterItem.estimateId ? holterItem.estimateId : 0,
            itemCode: holterItem.itemCode ? holterItem.itemCode : "",
            itemName: holterItem.itemName ? holterItem.itemName : "",
            estimateCode: holterItem.estimateCode ? holterItem.estimateCode : "",
          }
        );
      }
      let dealerData = {};
      if (this.data.belongInfo.role == role.role_dealer) {
        let child = this.$refs.dealerFacilitySetting;
        if (child) {
          dealerData = child.getInnerValue();
        }
      }

      return {
        userInfo:userInfo,
        belongInfo:belongInfo,
        inspectionItemInfo:inspectionItemInfo,
        portalPublicationRangeSettingInfo: portalPublicationRangeSettingInfo,
        pDashboardSettingInfo: pDashboardSettingInfo,
        usersInfo: usersInfo,
        hstSalesStaffsInfo: hstSalesStaffsInfo,
        psgSalesStaffsInfo: psgSalesStaffsInfo,
        kenshinSalesStaffsInfo: kenshinSalesStaffsInfo,
        holterSalesStaffsInfo: holterSalesStaffsInfo,
        cpapSalesStaffsInfo: cpapSalesStaffsInfo,
        inspectionReportSalesStaffsInfo: inspectionReportSalesStaffsInfo,
        coSalesStaffsInfo: coSalesStaffsInfo,
        hstItemInfo:hstItemInfo,
        psgItemInfo:psgItemInfo,
        kenshinItemInfo:kenshinItemInfo,
        holterItemInfo:holterItemInfo,
        initialUserInfo: this.initialUserInfo,
        dealerData:dealerData,
      }
    },
    update: async function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(true)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserUpdatePOST({
                body:body
              });
            },
            async function(result){
              if (_this.data.belongInfo.role == role.role_dealer) {
                await _this.apiCall(
                  client => client.apis.internalMaintenance.setMaintenanceFacilityByEstimateUpdatePOST({
                    body:body.dealerData
                  }),
                  () => {},
                  err => _this.showErrorMessage(result)
                );
              }
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    sendSalesOffice: async function(){
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(false)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserBranchForwardPOST({
                body:body
              });
            },
            async function(result){
              if (_this.data.belongInfo.role == role.role_dealer) {
                await _this.apiCall(
                  client => client.apis.internalMaintenance.setMaintenanceFacilityByEstimateUpdatePOST({
                    body:body.dealerData
                  }),
                  () => {},
                  err => _this.showErrorMessage(result)
                );
              }
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      }
    },
    regist: async function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(await this.inputCheck(true)){
          // Web Api Call
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserRegistrationPOST({
                body:body
              });
            },
            async function(result){
              if (_this.data.belongInfo.role == role.role_dealer) {
                await _this.apiCall(
                  client => client.apis.internalMaintenance.setMaintenanceFacilityByEstimateUpdatePOST({
                    body:body.dealerData
                  }),
                  () => {},
                  err => _this.showErrorMessage(result)
                );
              }
              _this.showSuccess(result, function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      }
    },
    //特殊な入力チェック
    inputCheck: async function(doSalesCheck){
      if ((this.data.belongInfo.role != role.role_hospital && this.data.belongInfo.role != role.role_dealer) || this.data.userInfo.status == extUserStatus.dummy) {
        if(this.data.userInfo.mail != this.mailAddrcomfirm){
          this.showErrorMessage("メールアドレス(確認)が一致しません。");
          return false;
        }
        if(this.data.userInfo.passPhrase){
          if(!this.data.userInfo.passPhrasePhoneNumber && !this.data.userInfo.passPhraseMail){
            this.showErrorMessage("パスフレーズ送信先(携帯番号)または、パスフレーズ送信先(Eメールアドレス)のどちらかを入力してください。");
            return false;
          }
        }
      }
      // ユーザーは最低1件
      if ((this.data.belongInfo.role == role.role_hospital || this.data.belongInfo.role == role.role_dealer) && this.data.userInfo.status != extUserStatus.dummy) {
        if (this.data.usersInfo.every(e => !e)) {
          this.showErrorMessage("ユーザーを追加してください。");
          return false;
        }
      }
      // 暫定ユーザーでない医療機関の各サービスの担当営業チェック
      // QA493 doSalesCheckがtrueの場合は本登録のためバリデーションをかける
      if (this.data.belongInfo.role == role.role_hospital && this.data.userInfo.status != extUserStatus.dummy && doSalesCheck) {
        if (this.useHst) {
          if (!this.data.belongInfo.hstSalesStaffId) {
            this.showErrorMessage("HST（睡眠検査機器配送サービス）の営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.hstSalesOfficeCode) {
            this.showErrorMessage("HST（睡眠検査機器配送サービス）の担当営業所を設定してください。");
            return false;
          }
        }
        if (this.usePsg) {
          if (!this.data.belongInfo.psgSalesStaffId) {
            this.showErrorMessage("PSG解析の営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.psgSalesOfficeCode) {
            this.showErrorMessage("PSG解析の担当営業所を設定してください。");
            return false;
          }
        }
        if (this.useKenshin) {
          if (!this.data.belongInfo.kenshinSalesStaffId) {
            this.showErrorMessage("企業検診の営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.kenshinSalesOfficeCode) {
            this.showErrorMessage("企業検診の担当営業所を設定してください。");
            return false;
          }
        }
        if (this.useHolter) {
          if (!this.data.belongInfo.holterSalesStaffId) {
            this.showErrorMessage("ホルター心電図配送サービスの営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.holterSalesOfficeCode) {
            this.showErrorMessage("ホルター心電図配送サービスの担当営業所を設定してください。");
            return false;
          }
        }
      }
      if (this.data.belongInfo.role == role.role_dealer && this.data.userInfo.status != extUserStatus.dummy && doSalesCheck) {
          if (!this.data.belongInfo.salesStaffId) {
            this.showErrorMessage("施設情報の営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.salesOfficeCode) {
            this.showErrorMessage("施設情報の担当営業所を設定してください。");
            return false;
          }

          // 施設別見積情報
          var child = this.$refs.dealerFacilitySetting;
          var dealerData = {};
          if (child) {
            dealerData = child.getInnerValue();
          }
          if (dealerData && dealerData.facilityId) {
            if (!dealerData.office) {
              this.showErrorMessage("配下施設の担当支店を設定してください。");
              return false;
            }
            if (!dealerData.salesOfficeCode) {
              this.showErrorMessage("配下施設の担当営業所(売上)を設定してください。");
              return false;
            }
            if (!dealerData.medicalInstitutionCode) {
              this.showErrorMessage("配下施設の得意先を設定してください。");
              return false;
            }
            if (!dealerData.salesStaffName) {
              this.showErrorMessage("配下施設の担当営業員を設定してください。");
              return false;
            }
        }
      }
      if (this.data.belongInfo.role == role.role_hospital && this.data.userInfo.status != extUserStatus.dummy && doSalesCheck) {
        if (this.useCPAP) {
          if (!this.data.belongInfo.cpapSalesStaffId) {
            this.showErrorMessage("CPAP指示書登録サービスの営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.cpapSalesOfficeCode) {
            this.showErrorMessage("CPAP指示書登録サービスの担当営業所を設定してください。");
            return false;
          }
        }
        if (!this.data.belongInfo.coSalesStaffId) {
          this.showErrorMessage("ケアオーケストレーターの営業担当者を設定してください。");
          return false;
        }
        if (!this.data.belongInfo.coSalesOfficeCode) {
          this.showErrorMessage("ケアオーケストレーターの担当営業所を設定してください。");
          return false;
        }
        if(this.useInspectionReport){
          if (!this.data.belongInfo.inspectionReportSalesStaffId) {
            this.showErrorMessage("呼吸点検報告書の営業担当者を設定してください。");
            return false;
          }
          if (!this.data.belongInfo.inspectionReportSalesOfficeCode) {
            this.showErrorMessage("呼吸点検報告書の担当営業所を設定してください。");
            return false;
          }
          if(!this.data.belongInfo.smsHospitalCode) {
            this.showErrorMessage("SMS医療機関を設定してください。");
            return false;
          }
        }
      }
      if(this.data.belongInfo.role != this.role.role_judgment && this.data.belongInfo.role != this.role.role_holter_judgment && this.data.belongInfo.role != this.role.role_analysis){
        if(!this.data.belongInfo.customerId){
          this.showErrorMessage("得意先を設定してください。");
          return false;
        }
        if(!this.data.belongInfo.branchStore){
          this.showErrorMessage("担当支店を設定してください。");
          return false;
        }
        if(doSalesCheck){
          //本登録、更新の場合
          if (this.data.belongInfo.role != role.role_hospital && this.data.belongInfo.role != role.role_dealer) {
            if(!this.data.belongInfo.salesStaffId){
              this.showErrorMessage("営業担当者を設定してください。");
              return false;
            }
            if(!this.data.belongInfo.salesOfficeCode){
              this.showErrorMessage("担当営業所を設定してください。");
              return false;
            }
          }
          //ディーラーフォロー
          if(this.data.belongInfo.dealerFollowFlg){
            if(this.data.belongInfo.dealerFollowMail == ""){
              this.showErrorMessage("ディーラー担当者メールアドレスを設定してください。");
              return false;
            }
          }
          //利用サービスにCPAPが含まれている場合
          if(this.isEnableService(this.data.belongInfo.useService, this.service.cpap)){
            if(!this.data.belongInfo.cpapSignedFlg){
              this.showErrorMessage("CPAP利用契約が完了していることを確認してください。");
              return false;
            }
          } else {
            //CPAP利用しない場合は設定を削除する
            this.data.belongInfo.cpapBillingCode = "";
            this.data.belongInfo.cpapSignedFlg = false;
            this.data.belongInfo.cpapUsageDetailBehalf = false;
          }
          if(!this.isEnableService(this.data.belongInfo.useService, this.service.holter)){
            this.data.belongInfo.holterDepositSignedFlg = false
            this.data.belongInfo.holterUseDepositFlg = false
            this.data.belongInfo.holterJudgmentFlg =  false
          }

          if(this.useInspectionReport){
            const messageDetails = [];
            const pcpPhonNumber = this.data.belongInfo.phoneNumber.replace(/(-)/g, '');
            const smsPhonNumber = this.smsHospital.phoneNumber.replace(/(-)/g, '');
            const pcpPostCode = this.data.belongInfo.customerPostCode.replace(/(-)/g, '');
            const smsPostCode = this.smsHospital.postCode.replace(/(-)/g, '');
            if (pcpPhonNumber != smsPhonNumber) {
              messageDetails.push("<li>電話番号</li>");
            }
            if (pcpPostCode != smsPostCode) {
              messageDetails.push("<li>郵便番号</li>");
            }

            if (messageDetails.length) {
              let message = "組織情報とSMS医療機関情報で、以下の情報に差異があるため医療機関の紐づけを行えません。\n";
              message += "呼吸点検報告書サービスが利用できませんが、処理を継続しますか？\n";
              message += messageDetails.join("");
              const confiermRes = await this.showComfirmMessage(message);
              if (confiermRes) {
                this.data.belongInfo.smsHospitalCode = null;
                this.data.belongInfo.smsHospitalName = null;
                this.smsHospital = null;
              } else {
                return false;
              }
            }
          }
        }
      }
      if (this.data.belongInfo.role == role.role_hospital) {
        if (this.useHolter && this.data.belongInfo.holterJudgmentFlg) {
          const holterJudgmentItems = this.data.holterItemInfo.filter(
            item => item.holterJudgmentFlg === true
          );
          if ( holterJudgmentItems.length > 0 && holterJudgmentItems.every(item => !item.estimateCode)) {
            this.showErrorMessage('「ホルター判定医」を有効にする場合は、「判定医結果付」の見積りコードの入力が必要です。');
            return false;
          }
        }
      }
      return true;
    },
    del: function() {
      var _this = this;
      // 暫定ユーザーでない医療機関、ディーラーはユーザー情報欄のユーザーを削除する
      var userIds = [];
      if ((_this.data.belongInfo.role == role.role_hospital || _this.data.belongInfo.role == role.role_dealer) && _this.data.userInfo.status != extUserStatus.dummy) {
        userIds = _this.initialUserInfo.map(u => u.id);
      } else {
        userIds =  [_this.data.userInfo.id];
      }
      this.$dialog.confirm({
        title: "　",
        message: "ユーザーを削除しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          _this.apiCall(
            function(client){
              const promises = userIds.map(id => {
                return client.apis.internalMaintenance.setMaintenanceExternalUserDeletePOST({
                  body: { userId: id }
                })
              })
              return Promise.all(promises)
            },
            async function(result){
              _this.showSuccess(result[0], function(){
                //前画面に戻る
                _this.back();
              });
            },
            function(result){
              _this.showErrorMessage(result[0]);
            }
          ); 
        }
      });
    },
    setCustomer: function(customerInfo){
      if(customerInfo){
        this.data.belongInfo.customerId = customerInfo.customerId;
        this.data.belongInfo.customerName = customerInfo.customerName;
      }
    },
    setCpapBilling: function(customerInfo){
      if(customerInfo){
        this.data.belongInfo.cpapBillingCode = customerInfo.customerId;
        this.data.belongInfo.cpapBillingName = customerInfo.customerName;
      }
    },
    setBilling: function(customerInfo){
      if(customerInfo){
        this.data.belongInfo.cpapBillingCode = customerInfo.customerId;
        this.data.belongInfo.cpapBillingName = customerInfo.customerName;
      }
    },
    setStaff: function(staffInfo, kindService, index){
      if(staffInfo){
        if (kindService == "hst") {
          if (index == -1) {
            this.data.belongInfo.hstSalesStaffId = staffInfo.id;
            this.data.belongInfo.hstSalesStaffName = staffInfo.name;
            this.data.belongInfo.hstSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.hstSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.hstSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.hstSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.hstSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "psg") {
          if (index == -1) {
            this.data.belongInfo.psgSalesStaffId = staffInfo.id;
            this.data.belongInfo.psgSalesStaffName = staffInfo.name;
            this.data.belongInfo.psgSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.psgSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.psgSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.psgSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.psgSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "kenshin") {
          if (index == -1) {
            this.data.belongInfo.kenshinSalesStaffId = staffInfo.id;
            this.data.belongInfo.kenshinSalesStaffName = staffInfo.name;
            this.data.belongInfo.kenshinSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.kenshinSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.kenshinSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.kenshinSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.kenshinSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "holter") {
          if (index == -1) {
            this.data.belongInfo.holterSalesStaffId = staffInfo.id;
            this.data.belongInfo.holterSalesStaffName = staffInfo.name;
            this.data.belongInfo.holterSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.holterSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.holterSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.holterSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.holterSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "cpap") {
          if (index == -1) {
            this.data.belongInfo.cpapSalesStaffId = staffInfo.id;
            this.data.belongInfo.cpapSalesStaffName = staffInfo.name;
            this.data.belongInfo.cpapSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.cpapSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.cpapSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.cpapSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.cpapSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "co") {
          if (index == -1) {
            this.data.belongInfo.coSalesStaffId = staffInfo.id;
            this.data.belongInfo.coSalesStaffName = staffInfo.name;
            this.data.belongInfo.coSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.coSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.coSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.coSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.coSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else if (kindService == "inspectionReport") {
          if (index == -1) {
            this.data.belongInfo.inspectionReportSalesStaffId = staffInfo.id;
            this.data.belongInfo.inspectionReportSalesStaffName = staffInfo.name;
            this.data.belongInfo.inspectionReportSalesStaffAddress = staffInfo.mail;
            this.data.belongInfo.inspectionReportSalesOfficeCode = staffInfo.salesOfficeCode;
          } else {
            this.data.inspectionReportSalesStaffsInfo[index].salesStaffId = staffInfo.id;
            this.data.inspectionReportSalesStaffsInfo[index].salesStaffName = staffInfo.name;
            this.data.inspectionReportSalesStaffsInfo[index].salesStaffAddress = staffInfo.mail;
          }
        } else {
          this.data.belongInfo.salesStaffId = staffInfo.id;
          this.data.belongInfo.salesStaffName = staffInfo.name;
          this.data.belongInfo.salesStaffAddress = staffInfo.mail;
          this.data.belongInfo.salesOfficeCode = staffInfo.salesOfficeCode;
        }
      }
    },
    setBill: function(billingInfo){
      if(billingInfo){
        this.data.belongInfo.billingId = billingInfo.customerId;
        this.data.belongInfo.billingName = billingInfo.customerName;
      }
    },
    doConnectConfirm: function() {
      let _this = this;
      // インテグレーターキーに全角文字が含まれていなく、36文字の場合
      if (!this.data.pDashboardInfo.pDashboardSettingInfo.integratorKey.match(/[^\x01-\x7E\uFF61-\uFF9F]/) 
          && this.data.pDashboardInfo.pDashboardSettingInfo.integratorKey.length == 36) {
        // Web Api Call
        this.apiCall(
          function(client){
            return client.apis.internalMaintenance.getCOOrgListPOST({
              body:{
                integratorUser: _this.data.pDashboardInfo.pDashboardSettingInfo.integratorUser,
                integratorKey: _this.data.pDashboardInfo.pDashboardSettingInfo.integratorKey,
                userId: _this.data.userInfo.id,
              }
            });
          },
          async function(result){
            // ケアオケの組織一覧取得が正常終了した場合のみ更新を行う
            if (result.obj.isSuccess) {
              _this.data.pDashboardInfo.pDashboardOrgList = result.obj.pDashboardOrgList;
              _this.existsOrgList = true;
              _this.isDoneConnectConfirmation = true;
            }
            _this.showSuccess(result);
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      } else {
        this.showErrorMessage("インテグレーターキーは半角36文字で入力してください。");
      }
    },
    goPDashboardMain: function(){
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message: pDashboardServiceName + "に移動します。編集中のデータがある場合は先に「更新」を行ってください。<br>" + pDashboardServiceName + "に移動しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setPDashboardUserMappingPOST({
                body:{
                  externalUserId: _this.uid,
                }
              });
            },
            async function(result){
              if(result && result.status == 200) {
                _this.isDoneDisplayConfirmation = true;
                await _this.$router.push({ name: "PDashboardMain" });
              } else {
                _this.showErrorMessage("予期しないエラーが発生しました。");
              }
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    doLastConfirm: function(){
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "この所属組織で" + pDashboardServiceName + "の利用を開始しますか？<br>開始すると本ユーザーに利用開始のお知らせメールを送信します。",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.updateLastConfirmationPOST({
                body:{
                  userId: _this.uid,
                  mail: _this.data.userInfo.mail
                }
              });
            },
            async function(result){
              _this.isDoneLastConfirmation = true;
              _this.showSuccess(result);
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    goFacilitySetting: function(){
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "施設別設定に移動します。編集中のデータがある場合は先に「更新」を行ってください。<br>施設別設定に移動しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          this.$router.push({
            name: "DealerFacilitySetting",
            query: {uid: this.uid, from:this.from, belongId: this.data.belongInfo.id}
          });
        }
      });
    },
    changeCheckBox: function(){
      this.data.belongInfo.useService = 0;
      if(this.useHst){
        this.data.belongInfo.useService += this.service.hst;
      }
      if(this.usePsg){
        this.data.belongInfo.useService += this.service.psg;
      }
      if(this.useKenshin){
        this.data.belongInfo.useService += this.service.kenshin;
      }
      if(this.useHolter){
        this.data.belongInfo.useService += this.service.holter;
      }
      if(this.useHolterAnalysis){
        this.data.belongInfo.useService += this.service.holter_analysis;
      }
      if(this.useCPAP){
        this.data.belongInfo.useService += this.service.cpap;
      }
      if(this.useInspectionReport){
        this.data.belongInfo.useService += this.service.inspection_report;
      }
    },
    changeHolterDepositSignedCheckBox(){      
      if(!this.data.belongInfo.holterDepositSignedFlg){
        this.data.belongInfo.holterUseDepositFlg = false;
      }
    },
    getExternalUserDetail: async function(){
      // Web Api Call
      var _this = this;
      var uid = this.uid
      var belongId = this.belongId
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceExternalUserDetailPOST({
            body:{
              userId: uid,
              belongsId: belongId
            }
          });
        },
        function(result){
          _this.data = result.obj
          console.log("result.obj : " + JSON.stringify(result.obj))
          if(_this.data.userInfo.mail && _this.data.userInfo.mail.startsWith("なし")){
            _this.data.userInfo.mail = "なし"
          }
          _this.useHst = _this.isEnableService(_this.data.belongInfo.useService, _this.service.hst);
          _this.usePsg = _this.isEnableService(_this.data.belongInfo.useService, _this.service.psg);
          _this.useKenshin = _this.isEnableService(_this.data.belongInfo.useService, _this.service.kenshin);
          _this.useHolter = _this.isEnableService(_this.data.belongInfo.useService, _this.service.holter);
          _this.useHolterAnalysis = _this.isEnableService(_this.data.belongInfo.useService, _this.service.holter_analysis);
          _this.usePDashboard = _this.data.pDashboardInfo.pDashboardSettingInfo.id ? true : false;
          _this.pDashboardSignedFlag = _this.data.pDashboardInfo.pDashboardSettingInfo.pDashboardSignedFlag;
          _this.isSelectedBelongOrg = _this.data.pDashboardInfo.pDashboardSettingInfo.orgId ? true : false;
          _this.isChangedBelongOrg = !_this.isSelectedBelongOrg;
          _this.isNothingIntegratorInfo = !_this.data.pDashboardInfo.pDashboardSettingInfo.integratorUser
                                            || !_this.data.pDashboardInfo.pDashboardSettingInfo.integratorKey ? true : false;
          _this.existsOrgList = _this.data.pDashboardInfo.pDashboardOrgList.length > 0 ? true : false;
          _this.initialBelongOrgId = _this.data.pDashboardInfo.pDashboardSettingInfo.orgId;
          _this.isDoneDisplayConfirmation = _this.data.pDashboardInfo.pDashboardSettingInfo.displayConfirmationFlag;
          _this.isDoneLastConfirmation = _this.data.pDashboardInfo.pDashboardSettingInfo.lastConfirmationFlag;
          _this.useCPAP = _this.isEnableService(_this.data.belongInfo.useService, _this.service.cpap);
          _this.useInspectionReport = _this.isEnableService(_this.data.belongInfo.useService, _this.service.inspection_report);
          _this.mailAddrcomfirm = _this.data.userInfo.mail;
          if(_this.data.belongInfo.cpapDealerRentalFlg){
            _this.cpapDealerRentalFlg = _this.data.belongInfo.cpapDealerRentalFlg + "";
          }
          _this.setPortalSettings(_this.data.portalPublicationRangeSettingInfo);
          _this.getSmsHospital();
          // 患者ダッシュボードの組織取得時にエラーが発生した場合のみメッセージを表示する
          if (_this.data.pDashboardInfo.errMessage) {
            _this.showErrorMessage(_this.data.pDashboardInfo.errMessage);
          }
          if (!_this.isInitialLoaded) {
            _this.initialUserInfo = JSON.parse(JSON.stringify(_this.data.usersInfo));
            _this.isInitialLoaded = true;
          }
          _this.isHolterJudgmentReady = _this.data.isHolterJudgmentReady
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    postCodeSearch: function(){
      var _this = this;
      return this.apiCall(
        function(client) {
          let postCode = _this.data.belongInfo.customerPostCode;
          return client.apis.apiCommon.getAddressFromPostCodePOST({
            body:{
              postCode: postCode
            }
          });
        },
        function(result) {
          _this.data.belongInfo.prefecture = result.obj.prefecture;
          _this.data.belongInfo.city = result.obj.city;
          _this.data.belongInfo.customerAddress1 = result.obj.town;
          _this.data.belongInfo.customerAddress2 = "";

          // QA476 住所設定後フォーカスを移動する
          _this.focusMove("customerAddress1");
          _this.digitErrorPostcode = false;
        },
      );
    },
    selectBelongOrg: function() {
      this.isSelectedBelongOrg = true;
      // 初期表示時に選択されていた組織と異なるものが選択された場合、画面確認・最終確認ボタンを押下不可にする
      if (this.data.pDashboardInfo.pDashboardSettingInfo.orgId != this.initialBelongOrgId) {
        this.isChangedBelongOrg = true;
      } else {
        this.isChangedBelongOrg = false;
      }
    },
    reload: async function() {
      await this.getExternalUserDetail();
    },
    searchBelongList: async function() {
      // 登録済みの所属先（一時登録フラグがONのもの）を検索する。
      if(this.searchCondition.belongsCustomerCode == "" && this.searchCondition.belongsName == ""){
        this.showErrorMessage("得意先コードまたは組織名を指定してください。");
      } else {
        let _this = this;
        return this.apiCall(
          function(client) {
            return client.apis.internalMaintenance.searchBelongListPOST({
              body: {
                belongsCustomerCode: _this.searchCondition.belongsCustomerCode,
                belongsName: _this.searchCondition.belongsName,
              }
            });
          },
          function(result) {
            // 検索結果表示
            _this.belongsList = result.obj;
          },
          function(error) {
            _this.showErrorMessage(error);
          }
        );
      }
    },
    changeBelongsId: async function() {
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: _this.selectedNewBelongs.medicalInstitutionFullName + "（"+ _this.selectedNewBelongs.customerId + "）の組織設定を使用しますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          _this.apiCall(
            function(client){
              //所属先IDを変更する。
              return client.apis.internalMaintenance.changeBelongsIdPOST({
                body:{
                  oldBelongsId: _this.data.belongInfo.id,
                  newBelongsId: _this.selectedNewBelongs.belongsId,
                }
              });
            },
            async function(result){
               //画面表示時の情報取得用の組織IDを変更後の組織IDに更新
              _this.belongId = result.obj.newBelongsId
              //変更後再描画
              _this.reload();
              _this.belongsSelected = true;
            },
            function(result){
              _this.showErrorMessage(result);
            }
          ); 
        }
      });
    },
    noChangeBelongsId: async function() {
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: _this.data.belongInfo.medicalInstitutionName +  " " + _this.data.belongInfo.departmentName + "を新しい組織として作成しますか？",
        cancelText: "キャンセル",
        onConfirm: () => {
          _this.belongsSelected = true;
        }
      });
    },
    // Search user portal publication range setting.
    setPortalSettings(portalPublicationRangeSetting) {
      if(portalPublicationRangeSetting) {
        this.isEnabledNotice = this.isUsedParam(portalPublicationRangeSetting.isEnabledNotice);
        this.isEnabledGuidance = this.isUsedParam(portalPublicationRangeSetting.isEnabledGuidance);
        this.isEnabledEvent = this.isUsedParam(portalPublicationRangeSetting.isEnabledEvent);
        this.isEnabledNews = this.isUsedParam(portalPublicationRangeSetting.isEnabledNews);
        this.isEnabledProduct = this.isUsedParam(portalPublicationRangeSetting.isEnabledProduct);
        this.isEnabledMail = this.isUsedParam(portalPublicationRangeSetting.isEnabledMail);
      }
    },
    isUsedParam(value) {
      return value != "";
    },
    isDisablePortalItem() {
      return (
        this.data.belongInfo.role == role.role_corporation ||
        this.data.belongInfo.role == role.role_accommodations
      );
    },
    disabledInspectionReport(_class) {
      let disabled = this.useInspectionReport ? '' : 'disabled';
      if (_class) {
        disabled += " " + _class;
      }
      return disabled;
    },
    setSmsHospital: function(smsHospital){
      if(smsHospital){
        this.smsHospital = smsHospital;
        this.data.belongInfo.smsHospitalCode = smsHospital.code;
        this.data.belongInfo.smsHospitalName = smsHospital.name;
      }
    },
    getSmsHospital: function(){
      if (this.data.belongInfo.smsHospitalCode) {
        // Web Api Call
        var _this = this;
        this.apiCall(
          function(client){
            return client.apis.smsInspectionReport.getSmsHospitalListPOST({
              body:{
                hospitalCode:  _this.data.belongInfo.smsHospitalCode,
              }
            });
          },
          function(result){
            const smsHospital = result.obj.find((elem) => elem.code == _this.data.belongInfo.smsHospitalCode);
            _this.smsHospital = smsHospital;
            if (smsHospital) {
              _this.data.belongInfo.smsHospitalName = _this.smsHospital.name;
            }
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    //No22_ダミーユーザー 
    updateCheck: async function() {
      var elements = document.getElementsByClassName("validate")
      var mailElement = document.getElementById("mailAddress")
      // 更新ボタン押下時はメールアドレスの形式のバリデーションを外す
      mailElement.setAttribute("validate", "required");

      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError || errMsg != ""){
        this.showErrorMessage(errMsg)
        return;
      }
      if (await this.inputCheck(true)) {
        //メールアドレスに@マークが「ある場合」は更新できない。（バリデーション）
        var target = this.data.userInfo.mail.indexOf('@') !== -1;
        var targetZen = this.data.userInfo.mail.indexOf('＠') !== -1;
        if(target || targetZen){
          var errMsg = "暫定ユーザーはメールアドレスを入力することはできません。メールアドレスを登録したい場合は医療機関とご調整のうえ、本登録ユーザーとして登録してください。"
          this.showErrorMessage(errMsg);
        } else {
          // メールアドレスに@マークが「ない場合」は更新
          var _this = this;
          var body = this.createBody();
          this.apiCall(
            function(client){
              return client.apis.internalMaintenance.setMaintenanceExternalUserUpdatePOST({
                body:body
              });
            },
            async function(result){
              _this.showSuccess(result);
                //再読み込み
                await _this.getExternalUserDetail();
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    dummyRegist: async function() {
      //メールアドレスに@マークが「ない場合」は更新できない。（バリデーション）
      //ポップアップ呼び出し
      if (this.data.userInfo.mail.indexOf('@') == -1) {
        var errMsg = "メールアドレスが不正です。<br>正しいメールアドレスを入力してください。"
        this.showErrorMessage(errMsg);
        return;
      }
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError || errMsg != ""){
        this.showErrorMessage(errMsg)
        return;
      }
      if (await this.inputCheck(true)) {
        this.dummyRegistModalActive = true
      }
    },
    dummyChangeRegist: async function() {
      var elements = document.getElementsByClassName("validate")
      var mailElement = document.getElementById("mailAddress")
      // 更新ボタン押下時はメールアドレスの形式のバリデーションを外す
      mailElement.setAttribute("validate", "required");
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError || errMsg != ""){
        this.showErrorMessage(errMsg)
        return;
      }
      if (await this.inputCheck(true)) {
        this.dummyChangeModalActive = true
      }
    },
    dummySendSalesOffice: function() {
      // Web Api Call
      var _this = this;
      var body = this.createBody();
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.setMaintenanceExternalUserBranchForwardPOST({
            body:body
          });
        },
        function(result){
          _this.showSuccess(result, function(){
            //前画面に戻る
            _this.back();
          });
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    // ユーザー情報モーダルへ遷移
    editUser: function(index,portalFlag) {
      this.userData = {
        id: this.data.usersInfo[index].id,
        familyName: this.data.usersInfo[index].familyName,
        firstName: this.data.usersInfo[index].firstName,
        familyNameKana: this.data.usersInfo[index].familyNameKana,
        firstNameKana: this.data.usersInfo[index].firstNameKana,
        mail: this.data.usersInfo[index].mail,
        mailAddrcomfirm: this.data.usersInfo[index].mail,
        passPhrase: this.data.usersInfo[index].passPhrase,
        passPhrasePhoneNumber: this.data.usersInfo[index].passPhrasePhoneNumber,
        passPhraseMail: this.data.usersInfo[index].passPhraseMail,
        cpapReport: this.data.usersInfo[index].isPDashboard ? this.data.usersInfo[index].isPDashboard : false,
        pDashboardSignedFlag: this.data.usersInfo[index].pDashboardSignedFlag,
        integratorUser: this.data.usersInfo[index].integratorUser,
        integratorKey: this.data.usersInfo[index].integratorKey,
        pDashboardOrgList: this.data.usersInfo[index].pDashboardOrgList,
        orgId: this.data.usersInfo[index].orgId,
        displayConfirmationFlag: this.data.usersInfo[index].displayConfirmationFlag,
        lastConfirmationFlag: this.data.usersInfo[index].lastConfirmationFlag,
        isEnabledNotice: this.data.usersInfo[index].isEnabledNotice,
        isEnabledGuidance: this.data.usersInfo[index].isEnabledGuidance,
        isEnabledEvent: this.data.usersInfo[index].isEnabledEvent,
        isEnabledNews: this.data.usersInfo[index].isEnabledNews,
        isEnabledProduct: this.data.usersInfo[index].isEnabledProduct,
        isEnabledMail: this.data.usersInfo[index].isEnabledMail,
        index:index,
        token:this.token,
        role:this.roleId,
        userStatus:this.data.userInfo.status,
        portalFlag:portalFlag,
      };
      this.userData = JSON.parse(JSON.stringify(this.userData));
      this.editFlag = true;
      if (this.data.usersInfo[index].id) {
        this.initialpDashboardInfo = {
          integratorUser: this.initialUserInfo[index].integratorUser ? this.initialUserInfo[index].integratorUser : '',
          integratorKey: this.initialUserInfo[index].integratorKey ? this.initialUserInfo[index].integratorKey : '',
          orgId: this.initialUserInfo[index].orgId ? this.initialUserInfo[index].orgId : '',
        }
      } else {
        this.initialpDashboardInfo = {
          integratorUser: '',
          integratorKey: '',
          orgId: '',
        }
      }
      this.initialpDashboardInfo = JSON.parse(JSON.stringify(this.initialpDashboardInfo));
      this.userAddModalActive=true;
    },
    // ユーザー情報モーダルから返却
    setUserInfo: function(userInfoObj){
      const lastIndex = this.data.usersInfo.length - 1;

      if(userInfoObj){
        var index = userInfoObj.index;

        // 削除
        if (userInfoObj.deleteFlag) {
          this.data.usersInfo.splice(index, 1);
        } else {
          if (lastIndex < index) {
            // 追加
            this.data.usersInfo.push({
              familyName: userInfoObj.familyName,
              firstName: userInfoObj.firstName,
              familyNameKana: userInfoObj.familyNameKana,
              firstNameKana: userInfoObj.firstNameKana,
              mail: userInfoObj.mail,
              passPhrase: userInfoObj.passPhrase,
              passPhrasePhoneNumber: userInfoObj.passPhrasePhoneNumber,
              passPhraseMail: userInfoObj.passPhraseMail,
              isPDashboard: userInfoObj.cpapReport,
              pDashboardSignedFlag: userInfoObj.pDashboardSignedFlag,
              integratorUser: userInfoObj.integratorUser,
              integratorKey: userInfoObj.integratorKey,
              orgId: userInfoObj.orgId,
              pDashboardOrgList: userInfoObj.pDashboardOrgList,
              displayConfirmationFlag: userInfoObj.displayConfirmationFlag,
              isEnabledNotice: userInfoObj.isEnabledNotice,
              isEnabledGuidance: userInfoObj.isEnabledGuidance,
              isEnabledEvent: userInfoObj.isEnabledEvent,
              isEnabledNews: userInfoObj.isEnabledNews,
              isEnabledProduct: userInfoObj.isEnabledProduct,
              isEnabledMail: userInfoObj.isEnabledMail,
            })
          } else {
            // 更新
            this.data.usersInfo[index].familyName = userInfoObj.familyName;
            this.data.usersInfo[index].firstName = userInfoObj.firstName;
            this.data.usersInfo[index].familyNameKana = userInfoObj.familyNameKana;
            this.data.usersInfo[index].firstNameKana = userInfoObj.firstNameKana;
            this.data.usersInfo[index].mail = userInfoObj.mail;
            this.data.usersInfo[index].passPhrase = userInfoObj.passPhrase;
            this.data.usersInfo[index].passPhrasePhoneNumber = userInfoObj.passPhrasePhoneNumber;
            this.data.usersInfo[index].passPhraseMail = userInfoObj.passPhraseMail;
            this.data.usersInfo[index].isPDashboard = userInfoObj.cpapReport;
            this.data.usersInfo[index].pDashboardSignedFlag = userInfoObj.pDashboardSignedFlag;
            this.data.usersInfo[index].integratorUser = userInfoObj.integratorUser;
            this.data.usersInfo[index].integratorKey = userInfoObj.integratorKey;
            this.data.usersInfo[index].orgId = userInfoObj.orgId,
            this.data.usersInfo[index].pDashboardOrgList = userInfoObj.pDashboardOrgList,
            this.data.usersInfo[index].displayConfirmationFlag = userInfoObj.displayConfirmationFlag,
            this.data.usersInfo[index].isEnabledNotice = userInfoObj.isEnabledNotice;
            this.data.usersInfo[index].isEnabledGuidance = userInfoObj.isEnabledGuidance;
            this.data.usersInfo[index].isEnabledEvent = userInfoObj.isEnabledEvent;
            this.data.usersInfo[index].isEnabledNews = userInfoObj.isEnabledNews;
            this.data.usersInfo[index].isEnabledProduct = userInfoObj.isEnabledProduct;
            this.data.usersInfo[index].isEnabledMail = userInfoObj.isEnabledMail;
          }
        }
      }
    },
    // ユーザー情報モーダルから患者ダッシュボード最終確認フラグ更新
    doPDushLastConfirm: function(userInfoObj){
      if(userInfoObj){
        var index = userInfoObj.index;
        this.data.usersInfo[index].lastConfirmationFlag = userInfoObj.lastConfirmationFlag
      }
    },
    // ポータル公開設定情報モーダルへ遷移
    confirmPortal: function(index) {
      this.portalSettingInfo = {
        isEnabledNotice: this.data.usersInfo[index].isEnabledNotice,
        isEnabledGuidance: this.data.usersInfo[index].isEnabledGuidance,
        isEnabledEvent: this.data.usersInfo[index].isEnabledEvent,
        isEnabledNews: this.data.usersInfo[index].isEnabledNews,
        isEnabledProduct: this.data.usersInfo[index].isEnabledProduct,
        isEnabledMail: this.data.usersInfo[index].isEnabledMail,
      };
      this.portalSettingInfo = JSON.parse(JSON.stringify(this.portalSettingInfo));
      this.portalConfirmModalActive=true;
    },
    // メール共有先削除
    deleteSalesStaffMail: function(kindService, index) {
      const THIS = this;
      this.$dialog.confirm({
        title: "　",
        message: "メールアドレスを削除しますか？",
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: () => THIS.excuteDeleteMail(kindService, index),
      });
    },
    excuteDeleteMail: function(kindService, index) {
      if (kindService == "cpap") {
        this.data.cpapSalesStaffsInfo[index].salesStaffId = 0;
        this.data.cpapSalesStaffsInfo[index].salesStaffName = "";
        this.data.cpapSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.cpapSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "hst") {
        this.data.hstSalesStaffsInfo[index].salesStaffId = 0;
        this.data.hstSalesStaffsInfo[index].salesStaffName = "";
        this.data.hstSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.hstSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "psg") {
        this.data.psgSalesStaffsInfo[index].salesStaffId = 0;
        this.data.psgSalesStaffsInfo[index].salesStaffName = "";
        this.data.psgSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.psgSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "kenshin") {
        this.data.kenshinSalesStaffsInfo[index].salesStaffId = 0;
        this.data.kenshinSalesStaffsInfo[index].salesStaffName = "";
        this.data.kenshinSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.kenshinSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "holter") {
        this.data.holterSalesStaffsInfo[index].salesStaffId = 0;
        this.data.holterSalesStaffsInfo[index].salesStaffName = "";
        this.data.holterSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.holterSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "co") {
        this.data.coSalesStaffsInfo[index].salesStaffId = 0;
        this.data.coSalesStaffsInfo[index].salesStaffName = "";
        this.data.coSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.coSalesStaffsInfo.splice(index, 1);
      } else if (kindService == "inspectionReport") {
        this.data.inspectionReportSalesStaffsInfo[index].salesStaffId = 0;
        this.data.inspectionReportSalesStaffsInfo[index].salesStaffName = "";
        this.data.inspectionReportSalesStaffsInfo[index].salesStaffAddress = "";
        this.data.inspectionReportSalesStaffsInfo.splice(index, 1);
      }
    },
    // メール共有先追加
    addSalesStaffMail: function(kindService) {
      const errmsg = "メールアドレスの追加は５件までです。";
      if (kindService == "cpap") {
        if (this.data.cpapSalesStaffsInfo.length < 5) {
          this.data.cpapSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "hst") {
        if (this.data.hstSalesStaffsInfo.length < 5) {
          this.data.hstSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "psg") {
        if (this.data.psgSalesStaffsInfo.length < 5) {
          this.data.psgSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "kenshin") {
        if (this.data.kenshinSalesStaffsInfo.length < 5) {
          this.data.kenshinSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "holter") {
        if (this.data.holterSalesStaffsInfo.length < 5) {
          this.data.holterSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "co") {
        if (this.data.coSalesStaffsInfo.length < 5) {
          this.data.coSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      } else if (kindService == "inspectionReport") {
        if (this.data.inspectionReportSalesStaffsInfo.length < 5) {
          this.data.inspectionReportSalesStaffsInfo.push({
            salesStaffId: 0,
            salesStaffName: "",
            salesStaffAddress: "",
          })
        } else {
          this.showErrorMessage(errmsg);
        }
      }
    },
  },
  data() {
    // 検査解析請求先情報 非活性
    var billingEnabled = false;
    var from = decodeURIComponent(this.$route.query["from"]);
    var uid = parseInt(decodeURIComponent(this.$route.query["uid"]), 10);
    var belongId = parseInt(decodeURIComponent(this.$route.query["belongId"]), 10);
    var searchConditions = this.$route.params["searchConditions"];
    var userInfo = this.getUserInfo();
    var salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    var branchOfficeMaster = this.getBranchOfficeMaster();
    branchOfficeMaster.unshift({});
    return {
      role: role,
      roleId: userInfo.roleId,
      token: userInfo.token,
      service:service,
      extUserStatus:extUserStatus,
      salesOfficeMaster:salesOfficeMaster,
      branchOfficeMaster:branchOfficeMaster,
      coUse: coUse,
      data: null,
      useHst: null,
      usePsg: null,
      useKenshin: null,
      useHolter: null,
      useHolterAnalysis: null,
      useCPAP:null,
      useInspectionReport:null,
      customerModalActive: false,
      cpapBillingModalActive:false,
      staffModalActive: false,
      billModalActive: false,
      coImportModalActive: false,
      smsHospitalModalActive: false,
      from: from,
      uid: uid,
      belongId: belongId,
      cpapDealerRentalFlg: "false",
      searchConditions:searchConditions,
      mailAddrcomfirm: "",
      cpapSignedFlg:false,
      cpapUsageDetailBehalf:false,
      billingEnabled: billingEnabled,
      belongsSelected:false,
      belongsList: [],
      selectedNewBelongs: null,
      searchCondition:{belongsCustomerCode:"", belongsName:""},
      invalidPostcode: false,
      invalidPhoneNumber: false,
      pDashboardServiceName: pDashboardServiceName,
      existsOrgList: false,
      isDoneConnectConfirmation: false,
      isDoneDisplayConfirmation: false,
      isDoneLastConfirmation: false,
      pDashboardSignedFlag: false,
      isNothingIntegratorInfo: false,
      isSelectedBelongOrg: false,
      isChangedBelongOrg: false,
      initialBelongOrgId: null,
      usePDashboard: false,
      // portal menu
      isEnabledNotice: true,
      isEnabledGuidance: true,
      isEnabledEvent: true,
      isEnabledNews: true,
      isEnabledProduct: true,
      isEnabledMail: true,
      dummyRegistModalActive: false,
      dummyChangeModalActive: false,
      dummyChangeRegistModalActive: false,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      isInitial:true,
      userAddModalActive:false,
      portalConfirmModalActive:false,
      portalSettingInfo:{},
      userData:{},
      editFlag:false,
      kindService:"",
      salesStaffIndex:null,
      initialUserInfo:[],
      isInitialLoaded: false,
      targetData: {},
      facilityKey: Date.now(),
      initialpDashboardInfo:{},
      isHolterJudgmentReady: false,
    };
  },
  filters: {
    branchFilter(value,branchOfficeMaster){
      var target = branchOfficeMaster.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,
    customerModal: CustomerSelectModal,
    staffModal: StaffSelectModal,
    coImportModal: coImportModal,
    smsHospitalModal: SmsHospitalSelectModal,
    dummyRegistModal: DummyRegistModal,
    dummyChangeModal: DummyChangeModal,
    dealerFacilitySetting: DealerFacilitySetting,
    userAddModal: UserAddModal,
    portalConfirmModal: PortalConfirmModal,
  },
  mounted: async function() {
    await this.getExternalUserDetail();
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
    // アイコンに表示するステータスの文字を返す
    statusStr() {
      let str = "";
      if (this.data.userInfo.status == this.extUserStatus.tempReg) {
        str = this.extUserStatusStr.tempReg;
      } else if (this.data.userInfo.status == this.extUserStatus.brunchReview) {
        str = this.extUserStatusStr.brunchReview;
      } else if (this.data.userInfo.status == this.extUserStatus.registed) {
        str = this.extUserStatusStr.registed;
      } else if (this.data.userInfo.status == this.extUserStatus.dummy) {
        str = this.extUserStatusStr.dummy;
      }
      return str;
    }
  },
  watch: {
    "data.belongInfo.customerPostCode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitial) {
        this.isInitial = false;
        return
      }
      if (!this.invalidPostcode && newValue.length === 7) {
        this.postCodeSearch();
      }
    },
    "data.belongInfo.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "data.belongInfo.role"(newValue) {
      if(this.isDisablePortalItem()) {
        this.isEnabledGuidance = false;
        this.isEnabledEvent = false;
        this.isEnabledProduct = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.withButtonField {
  width: 760px !important;
}
.withButton {
  margin-left:10px !important;
  width:150px !important;
  height:29px !important;
}
.coImportButton {
  margin-left:50px !important;
  width:200px !important;
  height:29px !important;
  margin-top: -5px !important;
}
.nameInput {
  width: 462px !important;;
}
.caution {
  color: red;
  font-size: 0.75em;
}
.unlockButton {
  margin-left:10px;
  width:100px !important;
  height:29px !important;
  bottom: 2px;
}
.disabled {
  color: #7a7a7a;
}
.disabled::after {
  background-color: #7a7a7a;
}
.belongsSlectedBtn {
  width:500px !important;
}
.tag {
  width: 100px !important;
  height: inherit !important;
  font-size:20px !important;
  border-radius: 8px !important;
}
.dummy {
  width: 200px !important;
}
.facility-area {
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: left;
}
.condition-area table {
  border-collapse: collapse;
  width: 100%;
}
.condition-area th,
.condition-area td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align:center;
  color:#363636;
}
.iconButton {
  margin-left: 10px !important;
  width: 60px !important;
  height: 29px !important;
  color: white;
	border-color: #000894;
  background-color: #000894;
}
.selectButton {
  margin-left:10px !important;
  width:67px !important;
  height:29px !important;
}
.dealertTestSendButton {
  margin-left:10px !important;
  width:100px !important;
  height:29px !important;
}
.dealerAddButton {
  margin-left:10px !important;
  width:35px !important;
  height:29px !important;
}
.service-area th {
  width: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/user/ExternalUserEdit.vue